/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ViewAsModeImport } from './routes/view-as-mode'
import { Route as PublicRouteImport } from './routes/_public/route'
import { Route as AuthRouteImport } from './routes/_auth/route'
import { Route as IndexImport } from './routes/index'
import { Route as PublicLoginImport } from './routes/_public/login'
import { Route as PublicForgotPasswordImport } from './routes/_public/forgot-password'
import { Route as CallbackZaloRedirectImport } from './routes/_callback/zalo-redirect'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings/route'
import { Route as AuthMonitorsRouteImport } from './routes/_auth/monitors/route'
import { Route as AuthChatRouteImport } from './routes/_auth/chat/route'
import { Route as AuthAutomationRouteImport } from './routes/_auth/automation/route'
import { Route as AuthTicketsIndexImport } from './routes/_auth/tickets/index'
import { Route as AuthSmartQcIndexImport } from './routes/_auth/smart-qc/index'
import { Route as AuthCustomersIndexImport } from './routes/_auth/customers/index'
import { Route as AuthCampaignIndexImport } from './routes/_auth/campaign/index'
import { Route as AuthAutomationIndexImport } from './routes/_auth/automation/index'
import { Route as AuthTicketsTicketIdImport } from './routes/_auth/tickets/$ticketId'
import { Route as AuthSwitchboardQueueImport } from './routes/_auth/switchboard/queue'
import { Route as AuthSwitchboardIvrImport } from './routes/_auth/switchboard/ivr'
import { Route as AuthSwitchboardCallHistoryImport } from './routes/_auth/switchboard/call-history'
import { Route as AuthSettingsTimeWorkingImport } from './routes/_auth/settings/time-working'
import { Route as AuthSettingsBlacklistImport } from './routes/_auth/settings/blacklist'
import { Route as AuthReportTicketImport } from './routes/_auth/report/ticket'
import { Route as AuthReportSummaryImport } from './routes/_auth/report/summary'
import { Route as AuthReportGroupImport } from './routes/_auth/report/group'
import { Route as AuthReportCustomerImport } from './routes/_auth/report/customer'
import { Route as AuthReportCustomImport } from './routes/_auth/report/custom'
import { Route as AuthReportCallImport } from './routes/_auth/report/call'
import { Route as AuthReportAgentImport } from './routes/_auth/report/agent'
import { Route as AuthMonitorsDailyStatsImport } from './routes/_auth/monitors/daily-stats'
import { Route as AuthMonitorsChannelsImport } from './routes/_auth/monitors/channels'
import { Route as AuthMonitorsCallMonitorImport } from './routes/_auth/monitors/call-monitor'
import { Route as AuthMonitorsCallCenterImport } from './routes/_auth/monitors/call-center'
import { Route as AuthMonitorsAgentsImport } from './routes/_auth/monitors/agents'
import { Route as AuthCustomersTagsImport } from './routes/_auth/customers/tags'
import { Route as AuthCustomersGroupsImport } from './routes/_auth/customers/groups'
import { Route as AuthCustomersCustomerIdImport } from './routes/_auth/customers/$customerId'
import { Route as AuthChatTicketIdImport } from './routes/_auth/chat/$ticketId'
import { Route as AuthCampaignReportImport } from './routes/_auth/campaign/report'
import { Route as AuthSettingsUsersRouteImport } from './routes/_auth/settings/users/route'
import { Route as AuthSettingsTicketsRouteImport } from './routes/_auth/settings/tickets/route'
import { Route as AuthSettingsOthersRouteImport } from './routes/_auth/settings/others/route'
import { Route as AuthSettingsMultiChannelsRouteImport } from './routes/_auth/settings/multi-channels/route'
import { Route as AuthSmartQcManualQaIndexImport } from './routes/_auth/smart-qc/manualQa/index'
import { Route as AuthSmartQcKeywordIndexImport } from './routes/_auth/smart-qc/keyword/index'
import { Route as AuthSmartQcDashboardIndexImport } from './routes/_auth/smart-qc/dashboard/index'
import { Route as AuthSmartQcCriteriaIndexImport } from './routes/_auth/smart-qc/criteria/index'
import { Route as AuthSmartQcCampaignIndexImport } from './routes/_auth/smart-qc/campaign/index'
import { Route as AuthSmartQcAutoQaIndexImport } from './routes/_auth/smart-qc/autoQa/index'
import { Route as AuthSettingsTenantIndexImport } from './routes/_auth/settings/tenant/index'
import { Route as AuthSettingsTagsIndexImport } from './routes/_auth/settings/tags/index'
import { Route as AuthReportAdFunnelIndexImport } from './routes/_auth/report/ad-funnel/index'
import { Route as AuthCampaignCampaignIdIndexImport } from './routes/_auth/campaign/$campaignId/index'
import { Route as AuthAutomationEditorIndexImport } from './routes/_auth/automation/editor/index'
import { Route as AuthSmartQcCriteriaTemplateTypeImport } from './routes/_auth/smart-qc/criteria/$templateType'
import { Route as AuthSettingsUsersOrganizationsImport } from './routes/_auth/settings/users/organizations'
import { Route as AuthSettingsUsersMembersImport } from './routes/_auth/settings/users/members'
import { Route as AuthSettingsUsersDepartmentsImport } from './routes/_auth/settings/users/departments'
import { Route as AuthSettingsTicketsViewImport } from './routes/_auth/settings/tickets/view'
import { Route as AuthSettingsTicketsTicketTypeImport } from './routes/_auth/settings/tickets/ticket-type'
import { Route as AuthSettingsTicketsTemplateImport } from './routes/_auth/settings/tickets/template'
import { Route as AuthSettingsTicketsServiceImport } from './routes/_auth/settings/tickets/service'
import { Route as AuthSettingsTicketsPriorityImport } from './routes/_auth/settings/tickets/priority'
import { Route as AuthSettingsTicketsAttributesImport } from './routes/_auth/settings/tickets/attributes'
import { Route as AuthSettingsOthersTemplatesImport } from './routes/_auth/settings/others/templates'
import { Route as AuthSettingsOthersTemplateCatalogsImport } from './routes/_auth/settings/others/template-catalogs'
import { Route as AuthSettingsOrganizationsOrganizationIdImport } from './routes/_auth/settings/organizations/$organizationId'
import { Route as AuthSettingsMultiChannelsZaloImport } from './routes/_auth/settings/multi-channels/zalo'
import { Route as AuthSettingsMultiChannelsWhatsappImport } from './routes/_auth/settings/multi-channels/whatsapp'
import { Route as AuthSettingsMultiChannelsSmsImport } from './routes/_auth/settings/multi-channels/sms'
import { Route as AuthSettingsMultiChannelsLivechatImport } from './routes/_auth/settings/multi-channels/livechat'
import { Route as AuthSettingsMultiChannelsFacebookImport } from './routes/_auth/settings/multi-channels/facebook'
import { Route as AuthSettingsMultiChannelsEmailImport } from './routes/_auth/settings/multi-channels/email'
import { Route as AuthSettingsCustomersAttributesImport } from './routes/_auth/settings/customers/attributes'
import { Route as AuthCampaignCampaignIdReportImport } from './routes/_auth/campaign/$campaignId/report'
import { Route as AuthAutomationHistoryIdImport } from './routes/_auth/automation/history/$id'
import { Route as AuthAutomationEditorIdImport } from './routes/_auth/automation/editor/$id'
import { Route as AuthSettingsTenantConfigRouteImport } from './routes/_auth/settings/tenant/config/route'
import { Route as AuthSmartQcManualQaSmartQcIdIndexImport } from './routes/_auth/smart-qc/manualQa/$smartQcId/index'
import { Route as AuthSmartQcAutoQaSmartQcIdIndexImport } from './routes/_auth/smart-qc/autoQa/$smartQcId/index'
import { Route as AuthSettingsMultiChannelsZaloUserIndexImport } from './routes/_auth/settings/multi-channels/zalo-user/index'
import { Route as AuthSettingsTenantConfigTenantIdImport } from './routes/_auth/settings/tenant/config/$tenantId'
import { Route as AuthSettingsMultiChannelsZaloUserTenantIdImport } from './routes/_auth/settings/multi-channels/zalo-user/$tenantId'
import { Route as AuthSmartQcManualQaSmartQcIdCallsQcTicketIdImport } from './routes/_auth/smart-qc/manualQa/$smartQcId/calls/$qcTicketId'
import { Route as AuthSmartQcAutoQaSmartQcIdCallsQcTicketIdImport } from './routes/_auth/smart-qc/autoQa/$smartQcId/calls/$qcTicketId'

// Create/Update Routes

const ViewAsModeRoute = ViewAsModeImport.update({
  id: '/view-as-mode',
  path: '/view-as-mode',
  getParentRoute: () => rootRoute,
} as any)

const PublicRouteRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRoute,
} as any)

const AuthRouteRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const PublicLoginRoute = PublicLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRouteRoute,
} as any)

const PublicForgotPasswordRoute = PublicForgotPasswordImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRouteRoute,
} as any)

const CallbackZaloRedirectRoute = CallbackZaloRedirectImport.update({
  id: '/_callback/zalo-redirect',
  path: '/zalo-redirect',
  getParentRoute: () => rootRoute,
} as any)

const AuthSettingsRouteRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthMonitorsRouteRoute = AuthMonitorsRouteImport.update({
  id: '/monitors',
  path: '/monitors',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthChatRouteRoute = AuthChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthAutomationRouteRoute = AuthAutomationRouteImport.update({
  id: '/automation',
  path: '/automation',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthTicketsIndexRoute = AuthTicketsIndexImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSmartQcIndexRoute = AuthSmartQcIndexImport.update({
  id: '/smart-qc/',
  path: '/smart-qc/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthCustomersIndexRoute = AuthCustomersIndexImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthCampaignIndexRoute = AuthCampaignIndexImport.update({
  id: '/campaign/',
  path: '/campaign/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthAutomationIndexRoute = AuthAutomationIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAutomationRouteRoute,
} as any)

const AuthTicketsTicketIdRoute = AuthTicketsTicketIdImport.update({
  id: '/tickets/$ticketId',
  path: '/tickets/$ticketId',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSwitchboardQueueRoute = AuthSwitchboardQueueImport.update({
  id: '/switchboard/queue',
  path: '/switchboard/queue',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSwitchboardIvrRoute = AuthSwitchboardIvrImport.update({
  id: '/switchboard/ivr',
  path: '/switchboard/ivr',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSwitchboardCallHistoryRoute = AuthSwitchboardCallHistoryImport.update(
  {
    id: '/switchboard/call-history',
    path: '/switchboard/call-history',
    getParentRoute: () => AuthRouteRoute,
  } as any,
)

const AuthSettingsTimeWorkingRoute = AuthSettingsTimeWorkingImport.update({
  id: '/time-working',
  path: '/time-working',
  getParentRoute: () => AuthSettingsRouteRoute,
} as any)

const AuthSettingsBlacklistRoute = AuthSettingsBlacklistImport.update({
  id: '/blacklist',
  path: '/blacklist',
  getParentRoute: () => AuthSettingsRouteRoute,
} as any)

const AuthReportTicketRoute = AuthReportTicketImport.update({
  id: '/report/ticket',
  path: '/report/ticket',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthReportSummaryRoute = AuthReportSummaryImport.update({
  id: '/report/summary',
  path: '/report/summary',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthReportGroupRoute = AuthReportGroupImport.update({
  id: '/report/group',
  path: '/report/group',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthReportCustomerRoute = AuthReportCustomerImport.update({
  id: '/report/customer',
  path: '/report/customer',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthReportCustomRoute = AuthReportCustomImport.update({
  id: '/report/custom',
  path: '/report/custom',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthReportCallRoute = AuthReportCallImport.update({
  id: '/report/call',
  path: '/report/call',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthReportAgentRoute = AuthReportAgentImport.update({
  id: '/report/agent',
  path: '/report/agent',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthMonitorsDailyStatsRoute = AuthMonitorsDailyStatsImport.update({
  id: '/daily-stats',
  path: '/daily-stats',
  getParentRoute: () => AuthMonitorsRouteRoute,
} as any)

const AuthMonitorsChannelsRoute = AuthMonitorsChannelsImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => AuthMonitorsRouteRoute,
} as any)

const AuthMonitorsCallMonitorRoute = AuthMonitorsCallMonitorImport.update({
  id: '/call-monitor',
  path: '/call-monitor',
  getParentRoute: () => AuthMonitorsRouteRoute,
} as any)

const AuthMonitorsCallCenterRoute = AuthMonitorsCallCenterImport.update({
  id: '/call-center',
  path: '/call-center',
  getParentRoute: () => AuthMonitorsRouteRoute,
} as any)

const AuthMonitorsAgentsRoute = AuthMonitorsAgentsImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AuthMonitorsRouteRoute,
} as any)

const AuthCustomersTagsRoute = AuthCustomersTagsImport.update({
  id: '/customers/tags',
  path: '/customers/tags',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthCustomersGroupsRoute = AuthCustomersGroupsImport.update({
  id: '/customers/groups',
  path: '/customers/groups',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthCustomersCustomerIdRoute = AuthCustomersCustomerIdImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthChatTicketIdRoute = AuthChatTicketIdImport.update({
  id: '/$ticketId',
  path: '/$ticketId',
  getParentRoute: () => AuthChatRouteRoute,
} as any)

const AuthCampaignReportRoute = AuthCampaignReportImport.update({
  id: '/campaign/report',
  path: '/campaign/report',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSettingsUsersRouteRoute = AuthSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthSettingsRouteRoute,
} as any)

const AuthSettingsTicketsRouteRoute = AuthSettingsTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AuthSettingsRouteRoute,
} as any)

const AuthSettingsOthersRouteRoute = AuthSettingsOthersRouteImport.update({
  id: '/others',
  path: '/others',
  getParentRoute: () => AuthSettingsRouteRoute,
} as any)

const AuthSettingsMultiChannelsRouteRoute =
  AuthSettingsMultiChannelsRouteImport.update({
    id: '/multi-channels',
    path: '/multi-channels',
    getParentRoute: () => AuthSettingsRouteRoute,
  } as any)

const AuthSmartQcManualQaIndexRoute = AuthSmartQcManualQaIndexImport.update({
  id: '/smart-qc/manualQa/',
  path: '/smart-qc/manualQa/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSmartQcKeywordIndexRoute = AuthSmartQcKeywordIndexImport.update({
  id: '/smart-qc/keyword/',
  path: '/smart-qc/keyword/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSmartQcDashboardIndexRoute = AuthSmartQcDashboardIndexImport.update({
  id: '/smart-qc/dashboard/',
  path: '/smart-qc/dashboard/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSmartQcCriteriaIndexRoute = AuthSmartQcCriteriaIndexImport.update({
  id: '/smart-qc/criteria/',
  path: '/smart-qc/criteria/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSmartQcCampaignIndexRoute = AuthSmartQcCampaignIndexImport.update({
  id: '/smart-qc/campaign/',
  path: '/smart-qc/campaign/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSmartQcAutoQaIndexRoute = AuthSmartQcAutoQaIndexImport.update({
  id: '/smart-qc/autoQa/',
  path: '/smart-qc/autoQa/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthSettingsTenantIndexRoute = AuthSettingsTenantIndexImport.update({
  id: '/tenant/',
  path: '/tenant/',
  getParentRoute: () => AuthSettingsRouteRoute,
} as any)

const AuthSettingsTagsIndexRoute = AuthSettingsTagsIndexImport.update({
  id: '/tags/',
  path: '/tags/',
  getParentRoute: () => AuthSettingsRouteRoute,
} as any)

const AuthReportAdFunnelIndexRoute = AuthReportAdFunnelIndexImport.update({
  id: '/report/ad-funnel/',
  path: '/report/ad-funnel/',
  getParentRoute: () => AuthRouteRoute,
} as any)

const AuthCampaignCampaignIdIndexRoute =
  AuthCampaignCampaignIdIndexImport.update({
    id: '/campaign/$campaignId/',
    path: '/campaign/$campaignId/',
    getParentRoute: () => AuthRouteRoute,
  } as any)

const AuthAutomationEditorIndexRoute = AuthAutomationEditorIndexImport.update({
  id: '/editor/',
  path: '/editor/',
  getParentRoute: () => AuthAutomationRouteRoute,
} as any)

const AuthSmartQcCriteriaTemplateTypeRoute =
  AuthSmartQcCriteriaTemplateTypeImport.update({
    id: '/smart-qc/criteria/$templateType',
    path: '/smart-qc/criteria/$templateType',
    getParentRoute: () => AuthRouteRoute,
  } as any)

const AuthSettingsUsersOrganizationsRoute =
  AuthSettingsUsersOrganizationsImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthSettingsUsersRouteRoute,
  } as any)

const AuthSettingsUsersMembersRoute = AuthSettingsUsersMembersImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AuthSettingsUsersRouteRoute,
} as any)

const AuthSettingsUsersDepartmentsRoute =
  AuthSettingsUsersDepartmentsImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => AuthSettingsUsersRouteRoute,
  } as any)

const AuthSettingsTicketsViewRoute = AuthSettingsTicketsViewImport.update({
  id: '/view',
  path: '/view',
  getParentRoute: () => AuthSettingsTicketsRouteRoute,
} as any)

const AuthSettingsTicketsTicketTypeRoute =
  AuthSettingsTicketsTicketTypeImport.update({
    id: '/ticket-type',
    path: '/ticket-type',
    getParentRoute: () => AuthSettingsTicketsRouteRoute,
  } as any)

const AuthSettingsTicketsTemplateRoute =
  AuthSettingsTicketsTemplateImport.update({
    id: '/template',
    path: '/template',
    getParentRoute: () => AuthSettingsTicketsRouteRoute,
  } as any)

const AuthSettingsTicketsServiceRoute = AuthSettingsTicketsServiceImport.update(
  {
    id: '/service',
    path: '/service',
    getParentRoute: () => AuthSettingsTicketsRouteRoute,
  } as any,
)

const AuthSettingsTicketsPriorityRoute =
  AuthSettingsTicketsPriorityImport.update({
    id: '/priority',
    path: '/priority',
    getParentRoute: () => AuthSettingsTicketsRouteRoute,
  } as any)

const AuthSettingsTicketsAttributesRoute =
  AuthSettingsTicketsAttributesImport.update({
    id: '/attributes',
    path: '/attributes',
    getParentRoute: () => AuthSettingsTicketsRouteRoute,
  } as any)

const AuthSettingsOthersTemplatesRoute =
  AuthSettingsOthersTemplatesImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthSettingsOthersRouteRoute,
  } as any)

const AuthSettingsOthersTemplateCatalogsRoute =
  AuthSettingsOthersTemplateCatalogsImport.update({
    id: '/template-catalogs',
    path: '/template-catalogs',
    getParentRoute: () => AuthSettingsOthersRouteRoute,
  } as any)

const AuthSettingsOrganizationsOrganizationIdRoute =
  AuthSettingsOrganizationsOrganizationIdImport.update({
    id: '/organizations/$organizationId',
    path: '/organizations/$organizationId',
    getParentRoute: () => AuthSettingsRouteRoute,
  } as any)

const AuthSettingsMultiChannelsZaloRoute =
  AuthSettingsMultiChannelsZaloImport.update({
    id: '/zalo',
    path: '/zalo',
    getParentRoute: () => AuthSettingsMultiChannelsRouteRoute,
  } as any)

const AuthSettingsMultiChannelsWhatsappRoute =
  AuthSettingsMultiChannelsWhatsappImport.update({
    id: '/whatsapp',
    path: '/whatsapp',
    getParentRoute: () => AuthSettingsMultiChannelsRouteRoute,
  } as any)

const AuthSettingsMultiChannelsSmsRoute =
  AuthSettingsMultiChannelsSmsImport.update({
    id: '/sms',
    path: '/sms',
    getParentRoute: () => AuthSettingsMultiChannelsRouteRoute,
  } as any)

const AuthSettingsMultiChannelsLivechatRoute =
  AuthSettingsMultiChannelsLivechatImport.update({
    id: '/livechat',
    path: '/livechat',
    getParentRoute: () => AuthSettingsMultiChannelsRouteRoute,
  } as any)

const AuthSettingsMultiChannelsFacebookRoute =
  AuthSettingsMultiChannelsFacebookImport.update({
    id: '/facebook',
    path: '/facebook',
    getParentRoute: () => AuthSettingsMultiChannelsRouteRoute,
  } as any)

const AuthSettingsMultiChannelsEmailRoute =
  AuthSettingsMultiChannelsEmailImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () => AuthSettingsMultiChannelsRouteRoute,
  } as any)

const AuthSettingsCustomersAttributesRoute =
  AuthSettingsCustomersAttributesImport.update({
    id: '/customers/attributes',
    path: '/customers/attributes',
    getParentRoute: () => AuthSettingsRouteRoute,
  } as any)

const AuthCampaignCampaignIdReportRoute =
  AuthCampaignCampaignIdReportImport.update({
    id: '/campaign/$campaignId/report',
    path: '/campaign/$campaignId/report',
    getParentRoute: () => AuthRouteRoute,
  } as any)

const AuthAutomationHistoryIdRoute = AuthAutomationHistoryIdImport.update({
  id: '/history/$id',
  path: '/history/$id',
  getParentRoute: () => AuthAutomationRouteRoute,
} as any)

const AuthAutomationEditorIdRoute = AuthAutomationEditorIdImport.update({
  id: '/editor/$id',
  path: '/editor/$id',
  getParentRoute: () => AuthAutomationRouteRoute,
} as any)

const AuthSettingsTenantConfigRouteRoute =
  AuthSettingsTenantConfigRouteImport.update({
    id: '/tenant/config',
    path: '/tenant/config',
    getParentRoute: () => AuthSettingsRouteRoute,
  } as any)

const AuthSmartQcManualQaSmartQcIdIndexRoute =
  AuthSmartQcManualQaSmartQcIdIndexImport.update({
    id: '/smart-qc/manualQa/$smartQcId/',
    path: '/smart-qc/manualQa/$smartQcId/',
    getParentRoute: () => AuthRouteRoute,
  } as any)

const AuthSmartQcAutoQaSmartQcIdIndexRoute =
  AuthSmartQcAutoQaSmartQcIdIndexImport.update({
    id: '/smart-qc/autoQa/$smartQcId/',
    path: '/smart-qc/autoQa/$smartQcId/',
    getParentRoute: () => AuthRouteRoute,
  } as any)

const AuthSettingsMultiChannelsZaloUserIndexRoute =
  AuthSettingsMultiChannelsZaloUserIndexImport.update({
    id: '/zalo-user/',
    path: '/zalo-user/',
    getParentRoute: () => AuthSettingsMultiChannelsRouteRoute,
  } as any)

const AuthSettingsTenantConfigTenantIdRoute =
  AuthSettingsTenantConfigTenantIdImport.update({
    id: '/$tenantId',
    path: '/$tenantId',
    getParentRoute: () => AuthSettingsTenantConfigRouteRoute,
  } as any)

const AuthSettingsMultiChannelsZaloUserTenantIdRoute =
  AuthSettingsMultiChannelsZaloUserTenantIdImport.update({
    id: '/zalo-user/$tenantId',
    path: '/zalo-user/$tenantId',
    getParentRoute: () => AuthSettingsMultiChannelsRouteRoute,
  } as any)

const AuthSmartQcManualQaSmartQcIdCallsQcTicketIdRoute =
  AuthSmartQcManualQaSmartQcIdCallsQcTicketIdImport.update({
    id: '/smart-qc/manualQa/$smartQcId/calls/$qcTicketId',
    path: '/smart-qc/manualQa/$smartQcId/calls/$qcTicketId',
    getParentRoute: () => AuthRouteRoute,
  } as any)

const AuthSmartQcAutoQaSmartQcIdCallsQcTicketIdRoute =
  AuthSmartQcAutoQaSmartQcIdCallsQcTicketIdImport.update({
    id: '/smart-qc/autoQa/$smartQcId/calls/$qcTicketId',
    path: '/smart-qc/autoQa/$smartQcId/calls/$qcTicketId',
    getParentRoute: () => AuthRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRoute
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRoute
    }
    '/view-as-mode': {
      id: '/view-as-mode'
      path: '/view-as-mode'
      fullPath: '/view-as-mode'
      preLoaderRoute: typeof ViewAsModeImport
      parentRoute: typeof rootRoute
    }
    '/_auth/automation': {
      id: '/_auth/automation'
      path: '/automation'
      fullPath: '/automation'
      preLoaderRoute: typeof AuthAutomationRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/chat': {
      id: '/_auth/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AuthChatRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/monitors': {
      id: '/_auth/monitors'
      path: '/monitors'
      fullPath: '/monitors'
      preLoaderRoute: typeof AuthMonitorsRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRouteImport
    }
    '/_callback/zalo-redirect': {
      id: '/_callback/zalo-redirect'
      path: '/zalo-redirect'
      fullPath: '/zalo-redirect'
      preLoaderRoute: typeof CallbackZaloRedirectImport
      parentRoute: typeof rootRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordImport
      parentRoute: typeof PublicRouteImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginImport
      parentRoute: typeof PublicRouteImport
    }
    '/_auth/settings/multi-channels': {
      id: '/_auth/settings/multi-channels'
      path: '/multi-channels'
      fullPath: '/settings/multi-channels'
      preLoaderRoute: typeof AuthSettingsMultiChannelsRouteImport
      parentRoute: typeof AuthSettingsRouteImport
    }
    '/_auth/settings/others': {
      id: '/_auth/settings/others'
      path: '/others'
      fullPath: '/settings/others'
      preLoaderRoute: typeof AuthSettingsOthersRouteImport
      parentRoute: typeof AuthSettingsRouteImport
    }
    '/_auth/settings/tickets': {
      id: '/_auth/settings/tickets'
      path: '/tickets'
      fullPath: '/settings/tickets'
      preLoaderRoute: typeof AuthSettingsTicketsRouteImport
      parentRoute: typeof AuthSettingsRouteImport
    }
    '/_auth/settings/users': {
      id: '/_auth/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AuthSettingsUsersRouteImport
      parentRoute: typeof AuthSettingsRouteImport
    }
    '/_auth/campaign/report': {
      id: '/_auth/campaign/report'
      path: '/campaign/report'
      fullPath: '/campaign/report'
      preLoaderRoute: typeof AuthCampaignReportImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/chat/$ticketId': {
      id: '/_auth/chat/$ticketId'
      path: '/$ticketId'
      fullPath: '/chat/$ticketId'
      preLoaderRoute: typeof AuthChatTicketIdImport
      parentRoute: typeof AuthChatRouteImport
    }
    '/_auth/customers/$customerId': {
      id: '/_auth/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthCustomersCustomerIdImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/customers/groups': {
      id: '/_auth/customers/groups'
      path: '/customers/groups'
      fullPath: '/customers/groups'
      preLoaderRoute: typeof AuthCustomersGroupsImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/customers/tags': {
      id: '/_auth/customers/tags'
      path: '/customers/tags'
      fullPath: '/customers/tags'
      preLoaderRoute: typeof AuthCustomersTagsImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/monitors/agents': {
      id: '/_auth/monitors/agents'
      path: '/agents'
      fullPath: '/monitors/agents'
      preLoaderRoute: typeof AuthMonitorsAgentsImport
      parentRoute: typeof AuthMonitorsRouteImport
    }
    '/_auth/monitors/call-center': {
      id: '/_auth/monitors/call-center'
      path: '/call-center'
      fullPath: '/monitors/call-center'
      preLoaderRoute: typeof AuthMonitorsCallCenterImport
      parentRoute: typeof AuthMonitorsRouteImport
    }
    '/_auth/monitors/call-monitor': {
      id: '/_auth/monitors/call-monitor'
      path: '/call-monitor'
      fullPath: '/monitors/call-monitor'
      preLoaderRoute: typeof AuthMonitorsCallMonitorImport
      parentRoute: typeof AuthMonitorsRouteImport
    }
    '/_auth/monitors/channels': {
      id: '/_auth/monitors/channels'
      path: '/channels'
      fullPath: '/monitors/channels'
      preLoaderRoute: typeof AuthMonitorsChannelsImport
      parentRoute: typeof AuthMonitorsRouteImport
    }
    '/_auth/monitors/daily-stats': {
      id: '/_auth/monitors/daily-stats'
      path: '/daily-stats'
      fullPath: '/monitors/daily-stats'
      preLoaderRoute: typeof AuthMonitorsDailyStatsImport
      parentRoute: typeof AuthMonitorsRouteImport
    }
    '/_auth/report/agent': {
      id: '/_auth/report/agent'
      path: '/report/agent'
      fullPath: '/report/agent'
      preLoaderRoute: typeof AuthReportAgentImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/report/call': {
      id: '/_auth/report/call'
      path: '/report/call'
      fullPath: '/report/call'
      preLoaderRoute: typeof AuthReportCallImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/report/custom': {
      id: '/_auth/report/custom'
      path: '/report/custom'
      fullPath: '/report/custom'
      preLoaderRoute: typeof AuthReportCustomImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/report/customer': {
      id: '/_auth/report/customer'
      path: '/report/customer'
      fullPath: '/report/customer'
      preLoaderRoute: typeof AuthReportCustomerImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/report/group': {
      id: '/_auth/report/group'
      path: '/report/group'
      fullPath: '/report/group'
      preLoaderRoute: typeof AuthReportGroupImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/report/summary': {
      id: '/_auth/report/summary'
      path: '/report/summary'
      fullPath: '/report/summary'
      preLoaderRoute: typeof AuthReportSummaryImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/report/ticket': {
      id: '/_auth/report/ticket'
      path: '/report/ticket'
      fullPath: '/report/ticket'
      preLoaderRoute: typeof AuthReportTicketImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/settings/blacklist': {
      id: '/_auth/settings/blacklist'
      path: '/blacklist'
      fullPath: '/settings/blacklist'
      preLoaderRoute: typeof AuthSettingsBlacklistImport
      parentRoute: typeof AuthSettingsRouteImport
    }
    '/_auth/settings/time-working': {
      id: '/_auth/settings/time-working'
      path: '/time-working'
      fullPath: '/settings/time-working'
      preLoaderRoute: typeof AuthSettingsTimeWorkingImport
      parentRoute: typeof AuthSettingsRouteImport
    }
    '/_auth/switchboard/call-history': {
      id: '/_auth/switchboard/call-history'
      path: '/switchboard/call-history'
      fullPath: '/switchboard/call-history'
      preLoaderRoute: typeof AuthSwitchboardCallHistoryImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/switchboard/ivr': {
      id: '/_auth/switchboard/ivr'
      path: '/switchboard/ivr'
      fullPath: '/switchboard/ivr'
      preLoaderRoute: typeof AuthSwitchboardIvrImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/switchboard/queue': {
      id: '/_auth/switchboard/queue'
      path: '/switchboard/queue'
      fullPath: '/switchboard/queue'
      preLoaderRoute: typeof AuthSwitchboardQueueImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/tickets/$ticketId': {
      id: '/_auth/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/tickets/$ticketId'
      preLoaderRoute: typeof AuthTicketsTicketIdImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/automation/': {
      id: '/_auth/automation/'
      path: '/'
      fullPath: '/automation/'
      preLoaderRoute: typeof AuthAutomationIndexImport
      parentRoute: typeof AuthAutomationRouteImport
    }
    '/_auth/campaign/': {
      id: '/_auth/campaign/'
      path: '/campaign'
      fullPath: '/campaign'
      preLoaderRoute: typeof AuthCampaignIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/customers/': {
      id: '/_auth/customers/'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthCustomersIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/smart-qc/': {
      id: '/_auth/smart-qc/'
      path: '/smart-qc'
      fullPath: '/smart-qc'
      preLoaderRoute: typeof AuthSmartQcIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/tickets/': {
      id: '/_auth/tickets/'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AuthTicketsIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/settings/tenant/config': {
      id: '/_auth/settings/tenant/config'
      path: '/tenant/config'
      fullPath: '/settings/tenant/config'
      preLoaderRoute: typeof AuthSettingsTenantConfigRouteImport
      parentRoute: typeof AuthSettingsRouteImport
    }
    '/_auth/automation/editor/$id': {
      id: '/_auth/automation/editor/$id'
      path: '/editor/$id'
      fullPath: '/automation/editor/$id'
      preLoaderRoute: typeof AuthAutomationEditorIdImport
      parentRoute: typeof AuthAutomationRouteImport
    }
    '/_auth/automation/history/$id': {
      id: '/_auth/automation/history/$id'
      path: '/history/$id'
      fullPath: '/automation/history/$id'
      preLoaderRoute: typeof AuthAutomationHistoryIdImport
      parentRoute: typeof AuthAutomationRouteImport
    }
    '/_auth/campaign/$campaignId/report': {
      id: '/_auth/campaign/$campaignId/report'
      path: '/campaign/$campaignId/report'
      fullPath: '/campaign/$campaignId/report'
      preLoaderRoute: typeof AuthCampaignCampaignIdReportImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/settings/customers/attributes': {
      id: '/_auth/settings/customers/attributes'
      path: '/customers/attributes'
      fullPath: '/settings/customers/attributes'
      preLoaderRoute: typeof AuthSettingsCustomersAttributesImport
      parentRoute: typeof AuthSettingsRouteImport
    }
    '/_auth/settings/multi-channels/email': {
      id: '/_auth/settings/multi-channels/email'
      path: '/email'
      fullPath: '/settings/multi-channels/email'
      preLoaderRoute: typeof AuthSettingsMultiChannelsEmailImport
      parentRoute: typeof AuthSettingsMultiChannelsRouteImport
    }
    '/_auth/settings/multi-channels/facebook': {
      id: '/_auth/settings/multi-channels/facebook'
      path: '/facebook'
      fullPath: '/settings/multi-channels/facebook'
      preLoaderRoute: typeof AuthSettingsMultiChannelsFacebookImport
      parentRoute: typeof AuthSettingsMultiChannelsRouteImport
    }
    '/_auth/settings/multi-channels/livechat': {
      id: '/_auth/settings/multi-channels/livechat'
      path: '/livechat'
      fullPath: '/settings/multi-channels/livechat'
      preLoaderRoute: typeof AuthSettingsMultiChannelsLivechatImport
      parentRoute: typeof AuthSettingsMultiChannelsRouteImport
    }
    '/_auth/settings/multi-channels/sms': {
      id: '/_auth/settings/multi-channels/sms'
      path: '/sms'
      fullPath: '/settings/multi-channels/sms'
      preLoaderRoute: typeof AuthSettingsMultiChannelsSmsImport
      parentRoute: typeof AuthSettingsMultiChannelsRouteImport
    }
    '/_auth/settings/multi-channels/whatsapp': {
      id: '/_auth/settings/multi-channels/whatsapp'
      path: '/whatsapp'
      fullPath: '/settings/multi-channels/whatsapp'
      preLoaderRoute: typeof AuthSettingsMultiChannelsWhatsappImport
      parentRoute: typeof AuthSettingsMultiChannelsRouteImport
    }
    '/_auth/settings/multi-channels/zalo': {
      id: '/_auth/settings/multi-channels/zalo'
      path: '/zalo'
      fullPath: '/settings/multi-channels/zalo'
      preLoaderRoute: typeof AuthSettingsMultiChannelsZaloImport
      parentRoute: typeof AuthSettingsMultiChannelsRouteImport
    }
    '/_auth/settings/organizations/$organizationId': {
      id: '/_auth/settings/organizations/$organizationId'
      path: '/organizations/$organizationId'
      fullPath: '/settings/organizations/$organizationId'
      preLoaderRoute: typeof AuthSettingsOrganizationsOrganizationIdImport
      parentRoute: typeof AuthSettingsRouteImport
    }
    '/_auth/settings/others/template-catalogs': {
      id: '/_auth/settings/others/template-catalogs'
      path: '/template-catalogs'
      fullPath: '/settings/others/template-catalogs'
      preLoaderRoute: typeof AuthSettingsOthersTemplateCatalogsImport
      parentRoute: typeof AuthSettingsOthersRouteImport
    }
    '/_auth/settings/others/templates': {
      id: '/_auth/settings/others/templates'
      path: '/templates'
      fullPath: '/settings/others/templates'
      preLoaderRoute: typeof AuthSettingsOthersTemplatesImport
      parentRoute: typeof AuthSettingsOthersRouteImport
    }
    '/_auth/settings/tickets/attributes': {
      id: '/_auth/settings/tickets/attributes'
      path: '/attributes'
      fullPath: '/settings/tickets/attributes'
      preLoaderRoute: typeof AuthSettingsTicketsAttributesImport
      parentRoute: typeof AuthSettingsTicketsRouteImport
    }
    '/_auth/settings/tickets/priority': {
      id: '/_auth/settings/tickets/priority'
      path: '/priority'
      fullPath: '/settings/tickets/priority'
      preLoaderRoute: typeof AuthSettingsTicketsPriorityImport
      parentRoute: typeof AuthSettingsTicketsRouteImport
    }
    '/_auth/settings/tickets/service': {
      id: '/_auth/settings/tickets/service'
      path: '/service'
      fullPath: '/settings/tickets/service'
      preLoaderRoute: typeof AuthSettingsTicketsServiceImport
      parentRoute: typeof AuthSettingsTicketsRouteImport
    }
    '/_auth/settings/tickets/template': {
      id: '/_auth/settings/tickets/template'
      path: '/template'
      fullPath: '/settings/tickets/template'
      preLoaderRoute: typeof AuthSettingsTicketsTemplateImport
      parentRoute: typeof AuthSettingsTicketsRouteImport
    }
    '/_auth/settings/tickets/ticket-type': {
      id: '/_auth/settings/tickets/ticket-type'
      path: '/ticket-type'
      fullPath: '/settings/tickets/ticket-type'
      preLoaderRoute: typeof AuthSettingsTicketsTicketTypeImport
      parentRoute: typeof AuthSettingsTicketsRouteImport
    }
    '/_auth/settings/tickets/view': {
      id: '/_auth/settings/tickets/view'
      path: '/view'
      fullPath: '/settings/tickets/view'
      preLoaderRoute: typeof AuthSettingsTicketsViewImport
      parentRoute: typeof AuthSettingsTicketsRouteImport
    }
    '/_auth/settings/users/departments': {
      id: '/_auth/settings/users/departments'
      path: '/departments'
      fullPath: '/settings/users/departments'
      preLoaderRoute: typeof AuthSettingsUsersDepartmentsImport
      parentRoute: typeof AuthSettingsUsersRouteImport
    }
    '/_auth/settings/users/members': {
      id: '/_auth/settings/users/members'
      path: '/members'
      fullPath: '/settings/users/members'
      preLoaderRoute: typeof AuthSettingsUsersMembersImport
      parentRoute: typeof AuthSettingsUsersRouteImport
    }
    '/_auth/settings/users/organizations': {
      id: '/_auth/settings/users/organizations'
      path: '/organizations'
      fullPath: '/settings/users/organizations'
      preLoaderRoute: typeof AuthSettingsUsersOrganizationsImport
      parentRoute: typeof AuthSettingsUsersRouteImport
    }
    '/_auth/smart-qc/criteria/$templateType': {
      id: '/_auth/smart-qc/criteria/$templateType'
      path: '/smart-qc/criteria/$templateType'
      fullPath: '/smart-qc/criteria/$templateType'
      preLoaderRoute: typeof AuthSmartQcCriteriaTemplateTypeImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/automation/editor/': {
      id: '/_auth/automation/editor/'
      path: '/editor'
      fullPath: '/automation/editor'
      preLoaderRoute: typeof AuthAutomationEditorIndexImport
      parentRoute: typeof AuthAutomationRouteImport
    }
    '/_auth/campaign/$campaignId/': {
      id: '/_auth/campaign/$campaignId/'
      path: '/campaign/$campaignId'
      fullPath: '/campaign/$campaignId'
      preLoaderRoute: typeof AuthCampaignCampaignIdIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/report/ad-funnel/': {
      id: '/_auth/report/ad-funnel/'
      path: '/report/ad-funnel'
      fullPath: '/report/ad-funnel'
      preLoaderRoute: typeof AuthReportAdFunnelIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/settings/tags/': {
      id: '/_auth/settings/tags/'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof AuthSettingsTagsIndexImport
      parentRoute: typeof AuthSettingsRouteImport
    }
    '/_auth/settings/tenant/': {
      id: '/_auth/settings/tenant/'
      path: '/tenant'
      fullPath: '/settings/tenant'
      preLoaderRoute: typeof AuthSettingsTenantIndexImport
      parentRoute: typeof AuthSettingsRouteImport
    }
    '/_auth/smart-qc/autoQa/': {
      id: '/_auth/smart-qc/autoQa/'
      path: '/smart-qc/autoQa'
      fullPath: '/smart-qc/autoQa'
      preLoaderRoute: typeof AuthSmartQcAutoQaIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/smart-qc/campaign/': {
      id: '/_auth/smart-qc/campaign/'
      path: '/smart-qc/campaign'
      fullPath: '/smart-qc/campaign'
      preLoaderRoute: typeof AuthSmartQcCampaignIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/smart-qc/criteria/': {
      id: '/_auth/smart-qc/criteria/'
      path: '/smart-qc/criteria'
      fullPath: '/smart-qc/criteria'
      preLoaderRoute: typeof AuthSmartQcCriteriaIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/smart-qc/dashboard/': {
      id: '/_auth/smart-qc/dashboard/'
      path: '/smart-qc/dashboard'
      fullPath: '/smart-qc/dashboard'
      preLoaderRoute: typeof AuthSmartQcDashboardIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/smart-qc/keyword/': {
      id: '/_auth/smart-qc/keyword/'
      path: '/smart-qc/keyword'
      fullPath: '/smart-qc/keyword'
      preLoaderRoute: typeof AuthSmartQcKeywordIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/smart-qc/manualQa/': {
      id: '/_auth/smart-qc/manualQa/'
      path: '/smart-qc/manualQa'
      fullPath: '/smart-qc/manualQa'
      preLoaderRoute: typeof AuthSmartQcManualQaIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/settings/multi-channels/zalo-user/$tenantId': {
      id: '/_auth/settings/multi-channels/zalo-user/$tenantId'
      path: '/zalo-user/$tenantId'
      fullPath: '/settings/multi-channels/zalo-user/$tenantId'
      preLoaderRoute: typeof AuthSettingsMultiChannelsZaloUserTenantIdImport
      parentRoute: typeof AuthSettingsMultiChannelsRouteImport
    }
    '/_auth/settings/tenant/config/$tenantId': {
      id: '/_auth/settings/tenant/config/$tenantId'
      path: '/$tenantId'
      fullPath: '/settings/tenant/config/$tenantId'
      preLoaderRoute: typeof AuthSettingsTenantConfigTenantIdImport
      parentRoute: typeof AuthSettingsTenantConfigRouteImport
    }
    '/_auth/settings/multi-channels/zalo-user/': {
      id: '/_auth/settings/multi-channels/zalo-user/'
      path: '/zalo-user'
      fullPath: '/settings/multi-channels/zalo-user'
      preLoaderRoute: typeof AuthSettingsMultiChannelsZaloUserIndexImport
      parentRoute: typeof AuthSettingsMultiChannelsRouteImport
    }
    '/_auth/smart-qc/autoQa/$smartQcId/': {
      id: '/_auth/smart-qc/autoQa/$smartQcId/'
      path: '/smart-qc/autoQa/$smartQcId'
      fullPath: '/smart-qc/autoQa/$smartQcId'
      preLoaderRoute: typeof AuthSmartQcAutoQaSmartQcIdIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/smart-qc/manualQa/$smartQcId/': {
      id: '/_auth/smart-qc/manualQa/$smartQcId/'
      path: '/smart-qc/manualQa/$smartQcId'
      fullPath: '/smart-qc/manualQa/$smartQcId'
      preLoaderRoute: typeof AuthSmartQcManualQaSmartQcIdIndexImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/smart-qc/autoQa/$smartQcId/calls/$qcTicketId': {
      id: '/_auth/smart-qc/autoQa/$smartQcId/calls/$qcTicketId'
      path: '/smart-qc/autoQa/$smartQcId/calls/$qcTicketId'
      fullPath: '/smart-qc/autoQa/$smartQcId/calls/$qcTicketId'
      preLoaderRoute: typeof AuthSmartQcAutoQaSmartQcIdCallsQcTicketIdImport
      parentRoute: typeof AuthRouteImport
    }
    '/_auth/smart-qc/manualQa/$smartQcId/calls/$qcTicketId': {
      id: '/_auth/smart-qc/manualQa/$smartQcId/calls/$qcTicketId'
      path: '/smart-qc/manualQa/$smartQcId/calls/$qcTicketId'
      fullPath: '/smart-qc/manualQa/$smartQcId/calls/$qcTicketId'
      preLoaderRoute: typeof AuthSmartQcManualQaSmartQcIdCallsQcTicketIdImport
      parentRoute: typeof AuthRouteImport
    }
  }
}

// Create and export the route tree

interface AuthAutomationRouteRouteChildren {
  AuthAutomationIndexRoute: typeof AuthAutomationIndexRoute
  AuthAutomationEditorIdRoute: typeof AuthAutomationEditorIdRoute
  AuthAutomationHistoryIdRoute: typeof AuthAutomationHistoryIdRoute
  AuthAutomationEditorIndexRoute: typeof AuthAutomationEditorIndexRoute
}

const AuthAutomationRouteRouteChildren: AuthAutomationRouteRouteChildren = {
  AuthAutomationIndexRoute: AuthAutomationIndexRoute,
  AuthAutomationEditorIdRoute: AuthAutomationEditorIdRoute,
  AuthAutomationHistoryIdRoute: AuthAutomationHistoryIdRoute,
  AuthAutomationEditorIndexRoute: AuthAutomationEditorIndexRoute,
}

const AuthAutomationRouteRouteWithChildren =
  AuthAutomationRouteRoute._addFileChildren(AuthAutomationRouteRouteChildren)

interface AuthChatRouteRouteChildren {
  AuthChatTicketIdRoute: typeof AuthChatTicketIdRoute
}

const AuthChatRouteRouteChildren: AuthChatRouteRouteChildren = {
  AuthChatTicketIdRoute: AuthChatTicketIdRoute,
}

const AuthChatRouteRouteWithChildren = AuthChatRouteRoute._addFileChildren(
  AuthChatRouteRouteChildren,
)

interface AuthMonitorsRouteRouteChildren {
  AuthMonitorsAgentsRoute: typeof AuthMonitorsAgentsRoute
  AuthMonitorsCallCenterRoute: typeof AuthMonitorsCallCenterRoute
  AuthMonitorsCallMonitorRoute: typeof AuthMonitorsCallMonitorRoute
  AuthMonitorsChannelsRoute: typeof AuthMonitorsChannelsRoute
  AuthMonitorsDailyStatsRoute: typeof AuthMonitorsDailyStatsRoute
}

const AuthMonitorsRouteRouteChildren: AuthMonitorsRouteRouteChildren = {
  AuthMonitorsAgentsRoute: AuthMonitorsAgentsRoute,
  AuthMonitorsCallCenterRoute: AuthMonitorsCallCenterRoute,
  AuthMonitorsCallMonitorRoute: AuthMonitorsCallMonitorRoute,
  AuthMonitorsChannelsRoute: AuthMonitorsChannelsRoute,
  AuthMonitorsDailyStatsRoute: AuthMonitorsDailyStatsRoute,
}

const AuthMonitorsRouteRouteWithChildren =
  AuthMonitorsRouteRoute._addFileChildren(AuthMonitorsRouteRouteChildren)

interface AuthSettingsMultiChannelsRouteRouteChildren {
  AuthSettingsMultiChannelsEmailRoute: typeof AuthSettingsMultiChannelsEmailRoute
  AuthSettingsMultiChannelsFacebookRoute: typeof AuthSettingsMultiChannelsFacebookRoute
  AuthSettingsMultiChannelsLivechatRoute: typeof AuthSettingsMultiChannelsLivechatRoute
  AuthSettingsMultiChannelsSmsRoute: typeof AuthSettingsMultiChannelsSmsRoute
  AuthSettingsMultiChannelsWhatsappRoute: typeof AuthSettingsMultiChannelsWhatsappRoute
  AuthSettingsMultiChannelsZaloRoute: typeof AuthSettingsMultiChannelsZaloRoute
  AuthSettingsMultiChannelsZaloUserTenantIdRoute: typeof AuthSettingsMultiChannelsZaloUserTenantIdRoute
  AuthSettingsMultiChannelsZaloUserIndexRoute: typeof AuthSettingsMultiChannelsZaloUserIndexRoute
}

const AuthSettingsMultiChannelsRouteRouteChildren: AuthSettingsMultiChannelsRouteRouteChildren =
  {
    AuthSettingsMultiChannelsEmailRoute: AuthSettingsMultiChannelsEmailRoute,
    AuthSettingsMultiChannelsFacebookRoute:
      AuthSettingsMultiChannelsFacebookRoute,
    AuthSettingsMultiChannelsLivechatRoute:
      AuthSettingsMultiChannelsLivechatRoute,
    AuthSettingsMultiChannelsSmsRoute: AuthSettingsMultiChannelsSmsRoute,
    AuthSettingsMultiChannelsWhatsappRoute:
      AuthSettingsMultiChannelsWhatsappRoute,
    AuthSettingsMultiChannelsZaloRoute: AuthSettingsMultiChannelsZaloRoute,
    AuthSettingsMultiChannelsZaloUserTenantIdRoute:
      AuthSettingsMultiChannelsZaloUserTenantIdRoute,
    AuthSettingsMultiChannelsZaloUserIndexRoute:
      AuthSettingsMultiChannelsZaloUserIndexRoute,
  }

const AuthSettingsMultiChannelsRouteRouteWithChildren =
  AuthSettingsMultiChannelsRouteRoute._addFileChildren(
    AuthSettingsMultiChannelsRouteRouteChildren,
  )

interface AuthSettingsOthersRouteRouteChildren {
  AuthSettingsOthersTemplateCatalogsRoute: typeof AuthSettingsOthersTemplateCatalogsRoute
  AuthSettingsOthersTemplatesRoute: typeof AuthSettingsOthersTemplatesRoute
}

const AuthSettingsOthersRouteRouteChildren: AuthSettingsOthersRouteRouteChildren =
  {
    AuthSettingsOthersTemplateCatalogsRoute:
      AuthSettingsOthersTemplateCatalogsRoute,
    AuthSettingsOthersTemplatesRoute: AuthSettingsOthersTemplatesRoute,
  }

const AuthSettingsOthersRouteRouteWithChildren =
  AuthSettingsOthersRouteRoute._addFileChildren(
    AuthSettingsOthersRouteRouteChildren,
  )

interface AuthSettingsTicketsRouteRouteChildren {
  AuthSettingsTicketsAttributesRoute: typeof AuthSettingsTicketsAttributesRoute
  AuthSettingsTicketsPriorityRoute: typeof AuthSettingsTicketsPriorityRoute
  AuthSettingsTicketsServiceRoute: typeof AuthSettingsTicketsServiceRoute
  AuthSettingsTicketsTemplateRoute: typeof AuthSettingsTicketsTemplateRoute
  AuthSettingsTicketsTicketTypeRoute: typeof AuthSettingsTicketsTicketTypeRoute
  AuthSettingsTicketsViewRoute: typeof AuthSettingsTicketsViewRoute
}

const AuthSettingsTicketsRouteRouteChildren: AuthSettingsTicketsRouteRouteChildren =
  {
    AuthSettingsTicketsAttributesRoute: AuthSettingsTicketsAttributesRoute,
    AuthSettingsTicketsPriorityRoute: AuthSettingsTicketsPriorityRoute,
    AuthSettingsTicketsServiceRoute: AuthSettingsTicketsServiceRoute,
    AuthSettingsTicketsTemplateRoute: AuthSettingsTicketsTemplateRoute,
    AuthSettingsTicketsTicketTypeRoute: AuthSettingsTicketsTicketTypeRoute,
    AuthSettingsTicketsViewRoute: AuthSettingsTicketsViewRoute,
  }

const AuthSettingsTicketsRouteRouteWithChildren =
  AuthSettingsTicketsRouteRoute._addFileChildren(
    AuthSettingsTicketsRouteRouteChildren,
  )

interface AuthSettingsUsersRouteRouteChildren {
  AuthSettingsUsersDepartmentsRoute: typeof AuthSettingsUsersDepartmentsRoute
  AuthSettingsUsersMembersRoute: typeof AuthSettingsUsersMembersRoute
  AuthSettingsUsersOrganizationsRoute: typeof AuthSettingsUsersOrganizationsRoute
}

const AuthSettingsUsersRouteRouteChildren: AuthSettingsUsersRouteRouteChildren =
  {
    AuthSettingsUsersDepartmentsRoute: AuthSettingsUsersDepartmentsRoute,
    AuthSettingsUsersMembersRoute: AuthSettingsUsersMembersRoute,
    AuthSettingsUsersOrganizationsRoute: AuthSettingsUsersOrganizationsRoute,
  }

const AuthSettingsUsersRouteRouteWithChildren =
  AuthSettingsUsersRouteRoute._addFileChildren(
    AuthSettingsUsersRouteRouteChildren,
  )

interface AuthSettingsTenantConfigRouteRouteChildren {
  AuthSettingsTenantConfigTenantIdRoute: typeof AuthSettingsTenantConfigTenantIdRoute
}

const AuthSettingsTenantConfigRouteRouteChildren: AuthSettingsTenantConfigRouteRouteChildren =
  {
    AuthSettingsTenantConfigTenantIdRoute:
      AuthSettingsTenantConfigTenantIdRoute,
  }

const AuthSettingsTenantConfigRouteRouteWithChildren =
  AuthSettingsTenantConfigRouteRoute._addFileChildren(
    AuthSettingsTenantConfigRouteRouteChildren,
  )

interface AuthSettingsRouteRouteChildren {
  AuthSettingsMultiChannelsRouteRoute: typeof AuthSettingsMultiChannelsRouteRouteWithChildren
  AuthSettingsOthersRouteRoute: typeof AuthSettingsOthersRouteRouteWithChildren
  AuthSettingsTicketsRouteRoute: typeof AuthSettingsTicketsRouteRouteWithChildren
  AuthSettingsUsersRouteRoute: typeof AuthSettingsUsersRouteRouteWithChildren
  AuthSettingsBlacklistRoute: typeof AuthSettingsBlacklistRoute
  AuthSettingsTimeWorkingRoute: typeof AuthSettingsTimeWorkingRoute
  AuthSettingsTenantConfigRouteRoute: typeof AuthSettingsTenantConfigRouteRouteWithChildren
  AuthSettingsCustomersAttributesRoute: typeof AuthSettingsCustomersAttributesRoute
  AuthSettingsOrganizationsOrganizationIdRoute: typeof AuthSettingsOrganizationsOrganizationIdRoute
  AuthSettingsTagsIndexRoute: typeof AuthSettingsTagsIndexRoute
  AuthSettingsTenantIndexRoute: typeof AuthSettingsTenantIndexRoute
}

const AuthSettingsRouteRouteChildren: AuthSettingsRouteRouteChildren = {
  AuthSettingsMultiChannelsRouteRoute:
    AuthSettingsMultiChannelsRouteRouteWithChildren,
  AuthSettingsOthersRouteRoute: AuthSettingsOthersRouteRouteWithChildren,
  AuthSettingsTicketsRouteRoute: AuthSettingsTicketsRouteRouteWithChildren,
  AuthSettingsUsersRouteRoute: AuthSettingsUsersRouteRouteWithChildren,
  AuthSettingsBlacklistRoute: AuthSettingsBlacklistRoute,
  AuthSettingsTimeWorkingRoute: AuthSettingsTimeWorkingRoute,
  AuthSettingsTenantConfigRouteRoute:
    AuthSettingsTenantConfigRouteRouteWithChildren,
  AuthSettingsCustomersAttributesRoute: AuthSettingsCustomersAttributesRoute,
  AuthSettingsOrganizationsOrganizationIdRoute:
    AuthSettingsOrganizationsOrganizationIdRoute,
  AuthSettingsTagsIndexRoute: AuthSettingsTagsIndexRoute,
  AuthSettingsTenantIndexRoute: AuthSettingsTenantIndexRoute,
}

const AuthSettingsRouteRouteWithChildren =
  AuthSettingsRouteRoute._addFileChildren(AuthSettingsRouteRouteChildren)

interface AuthRouteRouteChildren {
  AuthAutomationRouteRoute: typeof AuthAutomationRouteRouteWithChildren
  AuthChatRouteRoute: typeof AuthChatRouteRouteWithChildren
  AuthMonitorsRouteRoute: typeof AuthMonitorsRouteRouteWithChildren
  AuthSettingsRouteRoute: typeof AuthSettingsRouteRouteWithChildren
  AuthCampaignReportRoute: typeof AuthCampaignReportRoute
  AuthCustomersCustomerIdRoute: typeof AuthCustomersCustomerIdRoute
  AuthCustomersGroupsRoute: typeof AuthCustomersGroupsRoute
  AuthCustomersTagsRoute: typeof AuthCustomersTagsRoute
  AuthReportAgentRoute: typeof AuthReportAgentRoute
  AuthReportCallRoute: typeof AuthReportCallRoute
  AuthReportCustomRoute: typeof AuthReportCustomRoute
  AuthReportCustomerRoute: typeof AuthReportCustomerRoute
  AuthReportGroupRoute: typeof AuthReportGroupRoute
  AuthReportSummaryRoute: typeof AuthReportSummaryRoute
  AuthReportTicketRoute: typeof AuthReportTicketRoute
  AuthSwitchboardCallHistoryRoute: typeof AuthSwitchboardCallHistoryRoute
  AuthSwitchboardIvrRoute: typeof AuthSwitchboardIvrRoute
  AuthSwitchboardQueueRoute: typeof AuthSwitchboardQueueRoute
  AuthTicketsTicketIdRoute: typeof AuthTicketsTicketIdRoute
  AuthCampaignIndexRoute: typeof AuthCampaignIndexRoute
  AuthCustomersIndexRoute: typeof AuthCustomersIndexRoute
  AuthSmartQcIndexRoute: typeof AuthSmartQcIndexRoute
  AuthTicketsIndexRoute: typeof AuthTicketsIndexRoute
  AuthCampaignCampaignIdReportRoute: typeof AuthCampaignCampaignIdReportRoute
  AuthSmartQcCriteriaTemplateTypeRoute: typeof AuthSmartQcCriteriaTemplateTypeRoute
  AuthCampaignCampaignIdIndexRoute: typeof AuthCampaignCampaignIdIndexRoute
  AuthReportAdFunnelIndexRoute: typeof AuthReportAdFunnelIndexRoute
  AuthSmartQcAutoQaIndexRoute: typeof AuthSmartQcAutoQaIndexRoute
  AuthSmartQcCampaignIndexRoute: typeof AuthSmartQcCampaignIndexRoute
  AuthSmartQcCriteriaIndexRoute: typeof AuthSmartQcCriteriaIndexRoute
  AuthSmartQcDashboardIndexRoute: typeof AuthSmartQcDashboardIndexRoute
  AuthSmartQcKeywordIndexRoute: typeof AuthSmartQcKeywordIndexRoute
  AuthSmartQcManualQaIndexRoute: typeof AuthSmartQcManualQaIndexRoute
  AuthSmartQcAutoQaSmartQcIdIndexRoute: typeof AuthSmartQcAutoQaSmartQcIdIndexRoute
  AuthSmartQcManualQaSmartQcIdIndexRoute: typeof AuthSmartQcManualQaSmartQcIdIndexRoute
  AuthSmartQcAutoQaSmartQcIdCallsQcTicketIdRoute: typeof AuthSmartQcAutoQaSmartQcIdCallsQcTicketIdRoute
  AuthSmartQcManualQaSmartQcIdCallsQcTicketIdRoute: typeof AuthSmartQcManualQaSmartQcIdCallsQcTicketIdRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAutomationRouteRoute: AuthAutomationRouteRouteWithChildren,
  AuthChatRouteRoute: AuthChatRouteRouteWithChildren,
  AuthMonitorsRouteRoute: AuthMonitorsRouteRouteWithChildren,
  AuthSettingsRouteRoute: AuthSettingsRouteRouteWithChildren,
  AuthCampaignReportRoute: AuthCampaignReportRoute,
  AuthCustomersCustomerIdRoute: AuthCustomersCustomerIdRoute,
  AuthCustomersGroupsRoute: AuthCustomersGroupsRoute,
  AuthCustomersTagsRoute: AuthCustomersTagsRoute,
  AuthReportAgentRoute: AuthReportAgentRoute,
  AuthReportCallRoute: AuthReportCallRoute,
  AuthReportCustomRoute: AuthReportCustomRoute,
  AuthReportCustomerRoute: AuthReportCustomerRoute,
  AuthReportGroupRoute: AuthReportGroupRoute,
  AuthReportSummaryRoute: AuthReportSummaryRoute,
  AuthReportTicketRoute: AuthReportTicketRoute,
  AuthSwitchboardCallHistoryRoute: AuthSwitchboardCallHistoryRoute,
  AuthSwitchboardIvrRoute: AuthSwitchboardIvrRoute,
  AuthSwitchboardQueueRoute: AuthSwitchboardQueueRoute,
  AuthTicketsTicketIdRoute: AuthTicketsTicketIdRoute,
  AuthCampaignIndexRoute: AuthCampaignIndexRoute,
  AuthCustomersIndexRoute: AuthCustomersIndexRoute,
  AuthSmartQcIndexRoute: AuthSmartQcIndexRoute,
  AuthTicketsIndexRoute: AuthTicketsIndexRoute,
  AuthCampaignCampaignIdReportRoute: AuthCampaignCampaignIdReportRoute,
  AuthSmartQcCriteriaTemplateTypeRoute: AuthSmartQcCriteriaTemplateTypeRoute,
  AuthCampaignCampaignIdIndexRoute: AuthCampaignCampaignIdIndexRoute,
  AuthReportAdFunnelIndexRoute: AuthReportAdFunnelIndexRoute,
  AuthSmartQcAutoQaIndexRoute: AuthSmartQcAutoQaIndexRoute,
  AuthSmartQcCampaignIndexRoute: AuthSmartQcCampaignIndexRoute,
  AuthSmartQcCriteriaIndexRoute: AuthSmartQcCriteriaIndexRoute,
  AuthSmartQcDashboardIndexRoute: AuthSmartQcDashboardIndexRoute,
  AuthSmartQcKeywordIndexRoute: AuthSmartQcKeywordIndexRoute,
  AuthSmartQcManualQaIndexRoute: AuthSmartQcManualQaIndexRoute,
  AuthSmartQcAutoQaSmartQcIdIndexRoute: AuthSmartQcAutoQaSmartQcIdIndexRoute,
  AuthSmartQcManualQaSmartQcIdIndexRoute:
    AuthSmartQcManualQaSmartQcIdIndexRoute,
  AuthSmartQcAutoQaSmartQcIdCallsQcTicketIdRoute:
    AuthSmartQcAutoQaSmartQcIdCallsQcTicketIdRoute,
  AuthSmartQcManualQaSmartQcIdCallsQcTicketIdRoute:
    AuthSmartQcManualQaSmartQcIdCallsQcTicketIdRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLoginRoute: typeof PublicLoginRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof PublicRouteRouteWithChildren
  '/view-as-mode': typeof ViewAsModeRoute
  '/automation': typeof AuthAutomationRouteRouteWithChildren
  '/chat': typeof AuthChatRouteRouteWithChildren
  '/monitors': typeof AuthMonitorsRouteRouteWithChildren
  '/settings': typeof AuthSettingsRouteRouteWithChildren
  '/zalo-redirect': typeof CallbackZaloRedirectRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/settings/multi-channels': typeof AuthSettingsMultiChannelsRouteRouteWithChildren
  '/settings/others': typeof AuthSettingsOthersRouteRouteWithChildren
  '/settings/tickets': typeof AuthSettingsTicketsRouteRouteWithChildren
  '/settings/users': typeof AuthSettingsUsersRouteRouteWithChildren
  '/campaign/report': typeof AuthCampaignReportRoute
  '/chat/$ticketId': typeof AuthChatTicketIdRoute
  '/customers/$customerId': typeof AuthCustomersCustomerIdRoute
  '/customers/groups': typeof AuthCustomersGroupsRoute
  '/customers/tags': typeof AuthCustomersTagsRoute
  '/monitors/agents': typeof AuthMonitorsAgentsRoute
  '/monitors/call-center': typeof AuthMonitorsCallCenterRoute
  '/monitors/call-monitor': typeof AuthMonitorsCallMonitorRoute
  '/monitors/channels': typeof AuthMonitorsChannelsRoute
  '/monitors/daily-stats': typeof AuthMonitorsDailyStatsRoute
  '/report/agent': typeof AuthReportAgentRoute
  '/report/call': typeof AuthReportCallRoute
  '/report/custom': typeof AuthReportCustomRoute
  '/report/customer': typeof AuthReportCustomerRoute
  '/report/group': typeof AuthReportGroupRoute
  '/report/summary': typeof AuthReportSummaryRoute
  '/report/ticket': typeof AuthReportTicketRoute
  '/settings/blacklist': typeof AuthSettingsBlacklistRoute
  '/settings/time-working': typeof AuthSettingsTimeWorkingRoute
  '/switchboard/call-history': typeof AuthSwitchboardCallHistoryRoute
  '/switchboard/ivr': typeof AuthSwitchboardIvrRoute
  '/switchboard/queue': typeof AuthSwitchboardQueueRoute
  '/tickets/$ticketId': typeof AuthTicketsTicketIdRoute
  '/automation/': typeof AuthAutomationIndexRoute
  '/campaign': typeof AuthCampaignIndexRoute
  '/customers': typeof AuthCustomersIndexRoute
  '/smart-qc': typeof AuthSmartQcIndexRoute
  '/tickets': typeof AuthTicketsIndexRoute
  '/settings/tenant/config': typeof AuthSettingsTenantConfigRouteRouteWithChildren
  '/automation/editor/$id': typeof AuthAutomationEditorIdRoute
  '/automation/history/$id': typeof AuthAutomationHistoryIdRoute
  '/campaign/$campaignId/report': typeof AuthCampaignCampaignIdReportRoute
  '/settings/customers/attributes': typeof AuthSettingsCustomersAttributesRoute
  '/settings/multi-channels/email': typeof AuthSettingsMultiChannelsEmailRoute
  '/settings/multi-channels/facebook': typeof AuthSettingsMultiChannelsFacebookRoute
  '/settings/multi-channels/livechat': typeof AuthSettingsMultiChannelsLivechatRoute
  '/settings/multi-channels/sms': typeof AuthSettingsMultiChannelsSmsRoute
  '/settings/multi-channels/whatsapp': typeof AuthSettingsMultiChannelsWhatsappRoute
  '/settings/multi-channels/zalo': typeof AuthSettingsMultiChannelsZaloRoute
  '/settings/organizations/$organizationId': typeof AuthSettingsOrganizationsOrganizationIdRoute
  '/settings/others/template-catalogs': typeof AuthSettingsOthersTemplateCatalogsRoute
  '/settings/others/templates': typeof AuthSettingsOthersTemplatesRoute
  '/settings/tickets/attributes': typeof AuthSettingsTicketsAttributesRoute
  '/settings/tickets/priority': typeof AuthSettingsTicketsPriorityRoute
  '/settings/tickets/service': typeof AuthSettingsTicketsServiceRoute
  '/settings/tickets/template': typeof AuthSettingsTicketsTemplateRoute
  '/settings/tickets/ticket-type': typeof AuthSettingsTicketsTicketTypeRoute
  '/settings/tickets/view': typeof AuthSettingsTicketsViewRoute
  '/settings/users/departments': typeof AuthSettingsUsersDepartmentsRoute
  '/settings/users/members': typeof AuthSettingsUsersMembersRoute
  '/settings/users/organizations': typeof AuthSettingsUsersOrganizationsRoute
  '/smart-qc/criteria/$templateType': typeof AuthSmartQcCriteriaTemplateTypeRoute
  '/automation/editor': typeof AuthAutomationEditorIndexRoute
  '/campaign/$campaignId': typeof AuthCampaignCampaignIdIndexRoute
  '/report/ad-funnel': typeof AuthReportAdFunnelIndexRoute
  '/settings/tags': typeof AuthSettingsTagsIndexRoute
  '/settings/tenant': typeof AuthSettingsTenantIndexRoute
  '/smart-qc/autoQa': typeof AuthSmartQcAutoQaIndexRoute
  '/smart-qc/campaign': typeof AuthSmartQcCampaignIndexRoute
  '/smart-qc/criteria': typeof AuthSmartQcCriteriaIndexRoute
  '/smart-qc/dashboard': typeof AuthSmartQcDashboardIndexRoute
  '/smart-qc/keyword': typeof AuthSmartQcKeywordIndexRoute
  '/smart-qc/manualQa': typeof AuthSmartQcManualQaIndexRoute
  '/settings/multi-channels/zalo-user/$tenantId': typeof AuthSettingsMultiChannelsZaloUserTenantIdRoute
  '/settings/tenant/config/$tenantId': typeof AuthSettingsTenantConfigTenantIdRoute
  '/settings/multi-channels/zalo-user': typeof AuthSettingsMultiChannelsZaloUserIndexRoute
  '/smart-qc/autoQa/$smartQcId': typeof AuthSmartQcAutoQaSmartQcIdIndexRoute
  '/smart-qc/manualQa/$smartQcId': typeof AuthSmartQcManualQaSmartQcIdIndexRoute
  '/smart-qc/autoQa/$smartQcId/calls/$qcTicketId': typeof AuthSmartQcAutoQaSmartQcIdCallsQcTicketIdRoute
  '/smart-qc/manualQa/$smartQcId/calls/$qcTicketId': typeof AuthSmartQcManualQaSmartQcIdCallsQcTicketIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof PublicRouteRouteWithChildren
  '/view-as-mode': typeof ViewAsModeRoute
  '/chat': typeof AuthChatRouteRouteWithChildren
  '/monitors': typeof AuthMonitorsRouteRouteWithChildren
  '/settings': typeof AuthSettingsRouteRouteWithChildren
  '/zalo-redirect': typeof CallbackZaloRedirectRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/login': typeof PublicLoginRoute
  '/settings/multi-channels': typeof AuthSettingsMultiChannelsRouteRouteWithChildren
  '/settings/others': typeof AuthSettingsOthersRouteRouteWithChildren
  '/settings/tickets': typeof AuthSettingsTicketsRouteRouteWithChildren
  '/settings/users': typeof AuthSettingsUsersRouteRouteWithChildren
  '/campaign/report': typeof AuthCampaignReportRoute
  '/chat/$ticketId': typeof AuthChatTicketIdRoute
  '/customers/$customerId': typeof AuthCustomersCustomerIdRoute
  '/customers/groups': typeof AuthCustomersGroupsRoute
  '/customers/tags': typeof AuthCustomersTagsRoute
  '/monitors/agents': typeof AuthMonitorsAgentsRoute
  '/monitors/call-center': typeof AuthMonitorsCallCenterRoute
  '/monitors/call-monitor': typeof AuthMonitorsCallMonitorRoute
  '/monitors/channels': typeof AuthMonitorsChannelsRoute
  '/monitors/daily-stats': typeof AuthMonitorsDailyStatsRoute
  '/report/agent': typeof AuthReportAgentRoute
  '/report/call': typeof AuthReportCallRoute
  '/report/custom': typeof AuthReportCustomRoute
  '/report/customer': typeof AuthReportCustomerRoute
  '/report/group': typeof AuthReportGroupRoute
  '/report/summary': typeof AuthReportSummaryRoute
  '/report/ticket': typeof AuthReportTicketRoute
  '/settings/blacklist': typeof AuthSettingsBlacklistRoute
  '/settings/time-working': typeof AuthSettingsTimeWorkingRoute
  '/switchboard/call-history': typeof AuthSwitchboardCallHistoryRoute
  '/switchboard/ivr': typeof AuthSwitchboardIvrRoute
  '/switchboard/queue': typeof AuthSwitchboardQueueRoute
  '/tickets/$ticketId': typeof AuthTicketsTicketIdRoute
  '/automation': typeof AuthAutomationIndexRoute
  '/campaign': typeof AuthCampaignIndexRoute
  '/customers': typeof AuthCustomersIndexRoute
  '/smart-qc': typeof AuthSmartQcIndexRoute
  '/tickets': typeof AuthTicketsIndexRoute
  '/settings/tenant/config': typeof AuthSettingsTenantConfigRouteRouteWithChildren
  '/automation/editor/$id': typeof AuthAutomationEditorIdRoute
  '/automation/history/$id': typeof AuthAutomationHistoryIdRoute
  '/campaign/$campaignId/report': typeof AuthCampaignCampaignIdReportRoute
  '/settings/customers/attributes': typeof AuthSettingsCustomersAttributesRoute
  '/settings/multi-channels/email': typeof AuthSettingsMultiChannelsEmailRoute
  '/settings/multi-channels/facebook': typeof AuthSettingsMultiChannelsFacebookRoute
  '/settings/multi-channels/livechat': typeof AuthSettingsMultiChannelsLivechatRoute
  '/settings/multi-channels/sms': typeof AuthSettingsMultiChannelsSmsRoute
  '/settings/multi-channels/whatsapp': typeof AuthSettingsMultiChannelsWhatsappRoute
  '/settings/multi-channels/zalo': typeof AuthSettingsMultiChannelsZaloRoute
  '/settings/organizations/$organizationId': typeof AuthSettingsOrganizationsOrganizationIdRoute
  '/settings/others/template-catalogs': typeof AuthSettingsOthersTemplateCatalogsRoute
  '/settings/others/templates': typeof AuthSettingsOthersTemplatesRoute
  '/settings/tickets/attributes': typeof AuthSettingsTicketsAttributesRoute
  '/settings/tickets/priority': typeof AuthSettingsTicketsPriorityRoute
  '/settings/tickets/service': typeof AuthSettingsTicketsServiceRoute
  '/settings/tickets/template': typeof AuthSettingsTicketsTemplateRoute
  '/settings/tickets/ticket-type': typeof AuthSettingsTicketsTicketTypeRoute
  '/settings/tickets/view': typeof AuthSettingsTicketsViewRoute
  '/settings/users/departments': typeof AuthSettingsUsersDepartmentsRoute
  '/settings/users/members': typeof AuthSettingsUsersMembersRoute
  '/settings/users/organizations': typeof AuthSettingsUsersOrganizationsRoute
  '/smart-qc/criteria/$templateType': typeof AuthSmartQcCriteriaTemplateTypeRoute
  '/automation/editor': typeof AuthAutomationEditorIndexRoute
  '/campaign/$campaignId': typeof AuthCampaignCampaignIdIndexRoute
  '/report/ad-funnel': typeof AuthReportAdFunnelIndexRoute
  '/settings/tags': typeof AuthSettingsTagsIndexRoute
  '/settings/tenant': typeof AuthSettingsTenantIndexRoute
  '/smart-qc/autoQa': typeof AuthSmartQcAutoQaIndexRoute
  '/smart-qc/campaign': typeof AuthSmartQcCampaignIndexRoute
  '/smart-qc/criteria': typeof AuthSmartQcCriteriaIndexRoute
  '/smart-qc/dashboard': typeof AuthSmartQcDashboardIndexRoute
  '/smart-qc/keyword': typeof AuthSmartQcKeywordIndexRoute
  '/smart-qc/manualQa': typeof AuthSmartQcManualQaIndexRoute
  '/settings/multi-channels/zalo-user/$tenantId': typeof AuthSettingsMultiChannelsZaloUserTenantIdRoute
  '/settings/tenant/config/$tenantId': typeof AuthSettingsTenantConfigTenantIdRoute
  '/settings/multi-channels/zalo-user': typeof AuthSettingsMultiChannelsZaloUserIndexRoute
  '/smart-qc/autoQa/$smartQcId': typeof AuthSmartQcAutoQaSmartQcIdIndexRoute
  '/smart-qc/manualQa/$smartQcId': typeof AuthSmartQcManualQaSmartQcIdIndexRoute
  '/smart-qc/autoQa/$smartQcId/calls/$qcTicketId': typeof AuthSmartQcAutoQaSmartQcIdCallsQcTicketIdRoute
  '/smart-qc/manualQa/$smartQcId/calls/$qcTicketId': typeof AuthSmartQcManualQaSmartQcIdCallsQcTicketIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/view-as-mode': typeof ViewAsModeRoute
  '/_auth/automation': typeof AuthAutomationRouteRouteWithChildren
  '/_auth/chat': typeof AuthChatRouteRouteWithChildren
  '/_auth/monitors': typeof AuthMonitorsRouteRouteWithChildren
  '/_auth/settings': typeof AuthSettingsRouteRouteWithChildren
  '/_callback/zalo-redirect': typeof CallbackZaloRedirectRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/login': typeof PublicLoginRoute
  '/_auth/settings/multi-channels': typeof AuthSettingsMultiChannelsRouteRouteWithChildren
  '/_auth/settings/others': typeof AuthSettingsOthersRouteRouteWithChildren
  '/_auth/settings/tickets': typeof AuthSettingsTicketsRouteRouteWithChildren
  '/_auth/settings/users': typeof AuthSettingsUsersRouteRouteWithChildren
  '/_auth/campaign/report': typeof AuthCampaignReportRoute
  '/_auth/chat/$ticketId': typeof AuthChatTicketIdRoute
  '/_auth/customers/$customerId': typeof AuthCustomersCustomerIdRoute
  '/_auth/customers/groups': typeof AuthCustomersGroupsRoute
  '/_auth/customers/tags': typeof AuthCustomersTagsRoute
  '/_auth/monitors/agents': typeof AuthMonitorsAgentsRoute
  '/_auth/monitors/call-center': typeof AuthMonitorsCallCenterRoute
  '/_auth/monitors/call-monitor': typeof AuthMonitorsCallMonitorRoute
  '/_auth/monitors/channels': typeof AuthMonitorsChannelsRoute
  '/_auth/monitors/daily-stats': typeof AuthMonitorsDailyStatsRoute
  '/_auth/report/agent': typeof AuthReportAgentRoute
  '/_auth/report/call': typeof AuthReportCallRoute
  '/_auth/report/custom': typeof AuthReportCustomRoute
  '/_auth/report/customer': typeof AuthReportCustomerRoute
  '/_auth/report/group': typeof AuthReportGroupRoute
  '/_auth/report/summary': typeof AuthReportSummaryRoute
  '/_auth/report/ticket': typeof AuthReportTicketRoute
  '/_auth/settings/blacklist': typeof AuthSettingsBlacklistRoute
  '/_auth/settings/time-working': typeof AuthSettingsTimeWorkingRoute
  '/_auth/switchboard/call-history': typeof AuthSwitchboardCallHistoryRoute
  '/_auth/switchboard/ivr': typeof AuthSwitchboardIvrRoute
  '/_auth/switchboard/queue': typeof AuthSwitchboardQueueRoute
  '/_auth/tickets/$ticketId': typeof AuthTicketsTicketIdRoute
  '/_auth/automation/': typeof AuthAutomationIndexRoute
  '/_auth/campaign/': typeof AuthCampaignIndexRoute
  '/_auth/customers/': typeof AuthCustomersIndexRoute
  '/_auth/smart-qc/': typeof AuthSmartQcIndexRoute
  '/_auth/tickets/': typeof AuthTicketsIndexRoute
  '/_auth/settings/tenant/config': typeof AuthSettingsTenantConfigRouteRouteWithChildren
  '/_auth/automation/editor/$id': typeof AuthAutomationEditorIdRoute
  '/_auth/automation/history/$id': typeof AuthAutomationHistoryIdRoute
  '/_auth/campaign/$campaignId/report': typeof AuthCampaignCampaignIdReportRoute
  '/_auth/settings/customers/attributes': typeof AuthSettingsCustomersAttributesRoute
  '/_auth/settings/multi-channels/email': typeof AuthSettingsMultiChannelsEmailRoute
  '/_auth/settings/multi-channels/facebook': typeof AuthSettingsMultiChannelsFacebookRoute
  '/_auth/settings/multi-channels/livechat': typeof AuthSettingsMultiChannelsLivechatRoute
  '/_auth/settings/multi-channels/sms': typeof AuthSettingsMultiChannelsSmsRoute
  '/_auth/settings/multi-channels/whatsapp': typeof AuthSettingsMultiChannelsWhatsappRoute
  '/_auth/settings/multi-channels/zalo': typeof AuthSettingsMultiChannelsZaloRoute
  '/_auth/settings/organizations/$organizationId': typeof AuthSettingsOrganizationsOrganizationIdRoute
  '/_auth/settings/others/template-catalogs': typeof AuthSettingsOthersTemplateCatalogsRoute
  '/_auth/settings/others/templates': typeof AuthSettingsOthersTemplatesRoute
  '/_auth/settings/tickets/attributes': typeof AuthSettingsTicketsAttributesRoute
  '/_auth/settings/tickets/priority': typeof AuthSettingsTicketsPriorityRoute
  '/_auth/settings/tickets/service': typeof AuthSettingsTicketsServiceRoute
  '/_auth/settings/tickets/template': typeof AuthSettingsTicketsTemplateRoute
  '/_auth/settings/tickets/ticket-type': typeof AuthSettingsTicketsTicketTypeRoute
  '/_auth/settings/tickets/view': typeof AuthSettingsTicketsViewRoute
  '/_auth/settings/users/departments': typeof AuthSettingsUsersDepartmentsRoute
  '/_auth/settings/users/members': typeof AuthSettingsUsersMembersRoute
  '/_auth/settings/users/organizations': typeof AuthSettingsUsersOrganizationsRoute
  '/_auth/smart-qc/criteria/$templateType': typeof AuthSmartQcCriteriaTemplateTypeRoute
  '/_auth/automation/editor/': typeof AuthAutomationEditorIndexRoute
  '/_auth/campaign/$campaignId/': typeof AuthCampaignCampaignIdIndexRoute
  '/_auth/report/ad-funnel/': typeof AuthReportAdFunnelIndexRoute
  '/_auth/settings/tags/': typeof AuthSettingsTagsIndexRoute
  '/_auth/settings/tenant/': typeof AuthSettingsTenantIndexRoute
  '/_auth/smart-qc/autoQa/': typeof AuthSmartQcAutoQaIndexRoute
  '/_auth/smart-qc/campaign/': typeof AuthSmartQcCampaignIndexRoute
  '/_auth/smart-qc/criteria/': typeof AuthSmartQcCriteriaIndexRoute
  '/_auth/smart-qc/dashboard/': typeof AuthSmartQcDashboardIndexRoute
  '/_auth/smart-qc/keyword/': typeof AuthSmartQcKeywordIndexRoute
  '/_auth/smart-qc/manualQa/': typeof AuthSmartQcManualQaIndexRoute
  '/_auth/settings/multi-channels/zalo-user/$tenantId': typeof AuthSettingsMultiChannelsZaloUserTenantIdRoute
  '/_auth/settings/tenant/config/$tenantId': typeof AuthSettingsTenantConfigTenantIdRoute
  '/_auth/settings/multi-channels/zalo-user/': typeof AuthSettingsMultiChannelsZaloUserIndexRoute
  '/_auth/smart-qc/autoQa/$smartQcId/': typeof AuthSmartQcAutoQaSmartQcIdIndexRoute
  '/_auth/smart-qc/manualQa/$smartQcId/': typeof AuthSmartQcManualQaSmartQcIdIndexRoute
  '/_auth/smart-qc/autoQa/$smartQcId/calls/$qcTicketId': typeof AuthSmartQcAutoQaSmartQcIdCallsQcTicketIdRoute
  '/_auth/smart-qc/manualQa/$smartQcId/calls/$qcTicketId': typeof AuthSmartQcManualQaSmartQcIdCallsQcTicketIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/view-as-mode'
    | '/automation'
    | '/chat'
    | '/monitors'
    | '/settings'
    | '/zalo-redirect'
    | '/forgot-password'
    | '/login'
    | '/settings/multi-channels'
    | '/settings/others'
    | '/settings/tickets'
    | '/settings/users'
    | '/campaign/report'
    | '/chat/$ticketId'
    | '/customers/$customerId'
    | '/customers/groups'
    | '/customers/tags'
    | '/monitors/agents'
    | '/monitors/call-center'
    | '/monitors/call-monitor'
    | '/monitors/channels'
    | '/monitors/daily-stats'
    | '/report/agent'
    | '/report/call'
    | '/report/custom'
    | '/report/customer'
    | '/report/group'
    | '/report/summary'
    | '/report/ticket'
    | '/settings/blacklist'
    | '/settings/time-working'
    | '/switchboard/call-history'
    | '/switchboard/ivr'
    | '/switchboard/queue'
    | '/tickets/$ticketId'
    | '/automation/'
    | '/campaign'
    | '/customers'
    | '/smart-qc'
    | '/tickets'
    | '/settings/tenant/config'
    | '/automation/editor/$id'
    | '/automation/history/$id'
    | '/campaign/$campaignId/report'
    | '/settings/customers/attributes'
    | '/settings/multi-channels/email'
    | '/settings/multi-channels/facebook'
    | '/settings/multi-channels/livechat'
    | '/settings/multi-channels/sms'
    | '/settings/multi-channels/whatsapp'
    | '/settings/multi-channels/zalo'
    | '/settings/organizations/$organizationId'
    | '/settings/others/template-catalogs'
    | '/settings/others/templates'
    | '/settings/tickets/attributes'
    | '/settings/tickets/priority'
    | '/settings/tickets/service'
    | '/settings/tickets/template'
    | '/settings/tickets/ticket-type'
    | '/settings/tickets/view'
    | '/settings/users/departments'
    | '/settings/users/members'
    | '/settings/users/organizations'
    | '/smart-qc/criteria/$templateType'
    | '/automation/editor'
    | '/campaign/$campaignId'
    | '/report/ad-funnel'
    | '/settings/tags'
    | '/settings/tenant'
    | '/smart-qc/autoQa'
    | '/smart-qc/campaign'
    | '/smart-qc/criteria'
    | '/smart-qc/dashboard'
    | '/smart-qc/keyword'
    | '/smart-qc/manualQa'
    | '/settings/multi-channels/zalo-user/$tenantId'
    | '/settings/tenant/config/$tenantId'
    | '/settings/multi-channels/zalo-user'
    | '/smart-qc/autoQa/$smartQcId'
    | '/smart-qc/manualQa/$smartQcId'
    | '/smart-qc/autoQa/$smartQcId/calls/$qcTicketId'
    | '/smart-qc/manualQa/$smartQcId/calls/$qcTicketId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/view-as-mode'
    | '/chat'
    | '/monitors'
    | '/settings'
    | '/zalo-redirect'
    | '/forgot-password'
    | '/login'
    | '/settings/multi-channels'
    | '/settings/others'
    | '/settings/tickets'
    | '/settings/users'
    | '/campaign/report'
    | '/chat/$ticketId'
    | '/customers/$customerId'
    | '/customers/groups'
    | '/customers/tags'
    | '/monitors/agents'
    | '/monitors/call-center'
    | '/monitors/call-monitor'
    | '/monitors/channels'
    | '/monitors/daily-stats'
    | '/report/agent'
    | '/report/call'
    | '/report/custom'
    | '/report/customer'
    | '/report/group'
    | '/report/summary'
    | '/report/ticket'
    | '/settings/blacklist'
    | '/settings/time-working'
    | '/switchboard/call-history'
    | '/switchboard/ivr'
    | '/switchboard/queue'
    | '/tickets/$ticketId'
    | '/automation'
    | '/campaign'
    | '/customers'
    | '/smart-qc'
    | '/tickets'
    | '/settings/tenant/config'
    | '/automation/editor/$id'
    | '/automation/history/$id'
    | '/campaign/$campaignId/report'
    | '/settings/customers/attributes'
    | '/settings/multi-channels/email'
    | '/settings/multi-channels/facebook'
    | '/settings/multi-channels/livechat'
    | '/settings/multi-channels/sms'
    | '/settings/multi-channels/whatsapp'
    | '/settings/multi-channels/zalo'
    | '/settings/organizations/$organizationId'
    | '/settings/others/template-catalogs'
    | '/settings/others/templates'
    | '/settings/tickets/attributes'
    | '/settings/tickets/priority'
    | '/settings/tickets/service'
    | '/settings/tickets/template'
    | '/settings/tickets/ticket-type'
    | '/settings/tickets/view'
    | '/settings/users/departments'
    | '/settings/users/members'
    | '/settings/users/organizations'
    | '/smart-qc/criteria/$templateType'
    | '/automation/editor'
    | '/campaign/$campaignId'
    | '/report/ad-funnel'
    | '/settings/tags'
    | '/settings/tenant'
    | '/smart-qc/autoQa'
    | '/smart-qc/campaign'
    | '/smart-qc/criteria'
    | '/smart-qc/dashboard'
    | '/smart-qc/keyword'
    | '/smart-qc/manualQa'
    | '/settings/multi-channels/zalo-user/$tenantId'
    | '/settings/tenant/config/$tenantId'
    | '/settings/multi-channels/zalo-user'
    | '/smart-qc/autoQa/$smartQcId'
    | '/smart-qc/manualQa/$smartQcId'
    | '/smart-qc/autoQa/$smartQcId/calls/$qcTicketId'
    | '/smart-qc/manualQa/$smartQcId/calls/$qcTicketId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_public'
    | '/view-as-mode'
    | '/_auth/automation'
    | '/_auth/chat'
    | '/_auth/monitors'
    | '/_auth/settings'
    | '/_callback/zalo-redirect'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_auth/settings/multi-channels'
    | '/_auth/settings/others'
    | '/_auth/settings/tickets'
    | '/_auth/settings/users'
    | '/_auth/campaign/report'
    | '/_auth/chat/$ticketId'
    | '/_auth/customers/$customerId'
    | '/_auth/customers/groups'
    | '/_auth/customers/tags'
    | '/_auth/monitors/agents'
    | '/_auth/monitors/call-center'
    | '/_auth/monitors/call-monitor'
    | '/_auth/monitors/channels'
    | '/_auth/monitors/daily-stats'
    | '/_auth/report/agent'
    | '/_auth/report/call'
    | '/_auth/report/custom'
    | '/_auth/report/customer'
    | '/_auth/report/group'
    | '/_auth/report/summary'
    | '/_auth/report/ticket'
    | '/_auth/settings/blacklist'
    | '/_auth/settings/time-working'
    | '/_auth/switchboard/call-history'
    | '/_auth/switchboard/ivr'
    | '/_auth/switchboard/queue'
    | '/_auth/tickets/$ticketId'
    | '/_auth/automation/'
    | '/_auth/campaign/'
    | '/_auth/customers/'
    | '/_auth/smart-qc/'
    | '/_auth/tickets/'
    | '/_auth/settings/tenant/config'
    | '/_auth/automation/editor/$id'
    | '/_auth/automation/history/$id'
    | '/_auth/campaign/$campaignId/report'
    | '/_auth/settings/customers/attributes'
    | '/_auth/settings/multi-channels/email'
    | '/_auth/settings/multi-channels/facebook'
    | '/_auth/settings/multi-channels/livechat'
    | '/_auth/settings/multi-channels/sms'
    | '/_auth/settings/multi-channels/whatsapp'
    | '/_auth/settings/multi-channels/zalo'
    | '/_auth/settings/organizations/$organizationId'
    | '/_auth/settings/others/template-catalogs'
    | '/_auth/settings/others/templates'
    | '/_auth/settings/tickets/attributes'
    | '/_auth/settings/tickets/priority'
    | '/_auth/settings/tickets/service'
    | '/_auth/settings/tickets/template'
    | '/_auth/settings/tickets/ticket-type'
    | '/_auth/settings/tickets/view'
    | '/_auth/settings/users/departments'
    | '/_auth/settings/users/members'
    | '/_auth/settings/users/organizations'
    | '/_auth/smart-qc/criteria/$templateType'
    | '/_auth/automation/editor/'
    | '/_auth/campaign/$campaignId/'
    | '/_auth/report/ad-funnel/'
    | '/_auth/settings/tags/'
    | '/_auth/settings/tenant/'
    | '/_auth/smart-qc/autoQa/'
    | '/_auth/smart-qc/campaign/'
    | '/_auth/smart-qc/criteria/'
    | '/_auth/smart-qc/dashboard/'
    | '/_auth/smart-qc/keyword/'
    | '/_auth/smart-qc/manualQa/'
    | '/_auth/settings/multi-channels/zalo-user/$tenantId'
    | '/_auth/settings/tenant/config/$tenantId'
    | '/_auth/settings/multi-channels/zalo-user/'
    | '/_auth/smart-qc/autoQa/$smartQcId/'
    | '/_auth/smart-qc/manualQa/$smartQcId/'
    | '/_auth/smart-qc/autoQa/$smartQcId/calls/$qcTicketId'
    | '/_auth/smart-qc/manualQa/$smartQcId/calls/$qcTicketId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
  ViewAsModeRoute: typeof ViewAsModeRoute
  CallbackZaloRedirectRoute: typeof CallbackZaloRedirectRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  ViewAsModeRoute: ViewAsModeRoute,
  CallbackZaloRedirectRoute: CallbackZaloRedirectRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.jsx",
      "children": [
        "/",
        "/_auth",
        "/_public",
        "/view-as-mode",
        "/_callback/zalo-redirect"
      ]
    },
    "/": {
      "filePath": "index.jsx"
    },
    "/_auth": {
      "filePath": "_auth/route.jsx",
      "children": [
        "/_auth/automation",
        "/_auth/chat",
        "/_auth/monitors",
        "/_auth/settings",
        "/_auth/campaign/report",
        "/_auth/customers/$customerId",
        "/_auth/customers/groups",
        "/_auth/customers/tags",
        "/_auth/report/agent",
        "/_auth/report/call",
        "/_auth/report/custom",
        "/_auth/report/customer",
        "/_auth/report/group",
        "/_auth/report/summary",
        "/_auth/report/ticket",
        "/_auth/switchboard/call-history",
        "/_auth/switchboard/ivr",
        "/_auth/switchboard/queue",
        "/_auth/tickets/$ticketId",
        "/_auth/campaign/",
        "/_auth/customers/",
        "/_auth/smart-qc/",
        "/_auth/tickets/",
        "/_auth/campaign/$campaignId/report",
        "/_auth/smart-qc/criteria/$templateType",
        "/_auth/campaign/$campaignId/",
        "/_auth/report/ad-funnel/",
        "/_auth/smart-qc/autoQa/",
        "/_auth/smart-qc/campaign/",
        "/_auth/smart-qc/criteria/",
        "/_auth/smart-qc/dashboard/",
        "/_auth/smart-qc/keyword/",
        "/_auth/smart-qc/manualQa/",
        "/_auth/smart-qc/autoQa/$smartQcId/",
        "/_auth/smart-qc/manualQa/$smartQcId/",
        "/_auth/smart-qc/autoQa/$smartQcId/calls/$qcTicketId",
        "/_auth/smart-qc/manualQa/$smartQcId/calls/$qcTicketId"
      ]
    },
    "/_public": {
      "filePath": "_public/route.jsx",
      "children": [
        "/_public/forgot-password",
        "/_public/login"
      ]
    },
    "/view-as-mode": {
      "filePath": "view-as-mode.jsx"
    },
    "/_auth/automation": {
      "filePath": "_auth/automation/route.jsx",
      "parent": "/_auth",
      "children": [
        "/_auth/automation/",
        "/_auth/automation/editor/$id",
        "/_auth/automation/history/$id",
        "/_auth/automation/editor/"
      ]
    },
    "/_auth/chat": {
      "filePath": "_auth/chat/route.jsx",
      "parent": "/_auth",
      "children": [
        "/_auth/chat/$ticketId"
      ]
    },
    "/_auth/monitors": {
      "filePath": "_auth/monitors/route.jsx",
      "parent": "/_auth",
      "children": [
        "/_auth/monitors/agents",
        "/_auth/monitors/call-center",
        "/_auth/monitors/call-monitor",
        "/_auth/monitors/channels",
        "/_auth/monitors/daily-stats"
      ]
    },
    "/_auth/settings": {
      "filePath": "_auth/settings/route.jsx",
      "parent": "/_auth",
      "children": [
        "/_auth/settings/multi-channels",
        "/_auth/settings/others",
        "/_auth/settings/tickets",
        "/_auth/settings/users",
        "/_auth/settings/blacklist",
        "/_auth/settings/time-working",
        "/_auth/settings/tenant/config",
        "/_auth/settings/customers/attributes",
        "/_auth/settings/organizations/$organizationId",
        "/_auth/settings/tags/",
        "/_auth/settings/tenant/"
      ]
    },
    "/_callback/zalo-redirect": {
      "filePath": "_callback/zalo-redirect.jsx"
    },
    "/_public/forgot-password": {
      "filePath": "_public/forgot-password.jsx",
      "parent": "/_public"
    },
    "/_public/login": {
      "filePath": "_public/login.jsx",
      "parent": "/_public"
    },
    "/_auth/settings/multi-channels": {
      "filePath": "_auth/settings/multi-channels/route.jsx",
      "parent": "/_auth/settings",
      "children": [
        "/_auth/settings/multi-channels/email",
        "/_auth/settings/multi-channels/facebook",
        "/_auth/settings/multi-channels/livechat",
        "/_auth/settings/multi-channels/sms",
        "/_auth/settings/multi-channels/whatsapp",
        "/_auth/settings/multi-channels/zalo",
        "/_auth/settings/multi-channels/zalo-user/$tenantId",
        "/_auth/settings/multi-channels/zalo-user/"
      ]
    },
    "/_auth/settings/others": {
      "filePath": "_auth/settings/others/route.jsx",
      "parent": "/_auth/settings",
      "children": [
        "/_auth/settings/others/template-catalogs",
        "/_auth/settings/others/templates"
      ]
    },
    "/_auth/settings/tickets": {
      "filePath": "_auth/settings/tickets/route.jsx",
      "parent": "/_auth/settings",
      "children": [
        "/_auth/settings/tickets/attributes",
        "/_auth/settings/tickets/priority",
        "/_auth/settings/tickets/service",
        "/_auth/settings/tickets/template",
        "/_auth/settings/tickets/ticket-type",
        "/_auth/settings/tickets/view"
      ]
    },
    "/_auth/settings/users": {
      "filePath": "_auth/settings/users/route.jsx",
      "parent": "/_auth/settings",
      "children": [
        "/_auth/settings/users/departments",
        "/_auth/settings/users/members",
        "/_auth/settings/users/organizations"
      ]
    },
    "/_auth/campaign/report": {
      "filePath": "_auth/campaign/report.jsx",
      "parent": "/_auth"
    },
    "/_auth/chat/$ticketId": {
      "filePath": "_auth/chat/$ticketId.jsx",
      "parent": "/_auth/chat"
    },
    "/_auth/customers/$customerId": {
      "filePath": "_auth/customers/$customerId.jsx",
      "parent": "/_auth"
    },
    "/_auth/customers/groups": {
      "filePath": "_auth/customers/groups.jsx",
      "parent": "/_auth"
    },
    "/_auth/customers/tags": {
      "filePath": "_auth/customers/tags.jsx",
      "parent": "/_auth"
    },
    "/_auth/monitors/agents": {
      "filePath": "_auth/monitors/agents.jsx",
      "parent": "/_auth/monitors"
    },
    "/_auth/monitors/call-center": {
      "filePath": "_auth/monitors/call-center.jsx",
      "parent": "/_auth/monitors"
    },
    "/_auth/monitors/call-monitor": {
      "filePath": "_auth/monitors/call-monitor.jsx",
      "parent": "/_auth/monitors"
    },
    "/_auth/monitors/channels": {
      "filePath": "_auth/monitors/channels.jsx",
      "parent": "/_auth/monitors"
    },
    "/_auth/monitors/daily-stats": {
      "filePath": "_auth/monitors/daily-stats.jsx",
      "parent": "/_auth/monitors"
    },
    "/_auth/report/agent": {
      "filePath": "_auth/report/agent.jsx",
      "parent": "/_auth"
    },
    "/_auth/report/call": {
      "filePath": "_auth/report/call.jsx",
      "parent": "/_auth"
    },
    "/_auth/report/custom": {
      "filePath": "_auth/report/custom.jsx",
      "parent": "/_auth"
    },
    "/_auth/report/customer": {
      "filePath": "_auth/report/customer.jsx",
      "parent": "/_auth"
    },
    "/_auth/report/group": {
      "filePath": "_auth/report/group.jsx",
      "parent": "/_auth"
    },
    "/_auth/report/summary": {
      "filePath": "_auth/report/summary.jsx",
      "parent": "/_auth"
    },
    "/_auth/report/ticket": {
      "filePath": "_auth/report/ticket.jsx",
      "parent": "/_auth"
    },
    "/_auth/settings/blacklist": {
      "filePath": "_auth/settings/blacklist.jsx",
      "parent": "/_auth/settings"
    },
    "/_auth/settings/time-working": {
      "filePath": "_auth/settings/time-working.jsx",
      "parent": "/_auth/settings"
    },
    "/_auth/switchboard/call-history": {
      "filePath": "_auth/switchboard/call-history.jsx",
      "parent": "/_auth"
    },
    "/_auth/switchboard/ivr": {
      "filePath": "_auth/switchboard/ivr.jsx",
      "parent": "/_auth"
    },
    "/_auth/switchboard/queue": {
      "filePath": "_auth/switchboard/queue.jsx",
      "parent": "/_auth"
    },
    "/_auth/tickets/$ticketId": {
      "filePath": "_auth/tickets/$ticketId.jsx",
      "parent": "/_auth"
    },
    "/_auth/automation/": {
      "filePath": "_auth/automation/index.jsx",
      "parent": "/_auth/automation"
    },
    "/_auth/campaign/": {
      "filePath": "_auth/campaign/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/customers/": {
      "filePath": "_auth/customers/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/smart-qc/": {
      "filePath": "_auth/smart-qc/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/tickets/": {
      "filePath": "_auth/tickets/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/settings/tenant/config": {
      "filePath": "_auth/settings/tenant/config/route.jsx",
      "parent": "/_auth/settings",
      "children": [
        "/_auth/settings/tenant/config/$tenantId"
      ]
    },
    "/_auth/automation/editor/$id": {
      "filePath": "_auth/automation/editor/$id.jsx",
      "parent": "/_auth/automation"
    },
    "/_auth/automation/history/$id": {
      "filePath": "_auth/automation/history/$id.jsx",
      "parent": "/_auth/automation"
    },
    "/_auth/campaign/$campaignId/report": {
      "filePath": "_auth/campaign/$campaignId/report.jsx",
      "parent": "/_auth"
    },
    "/_auth/settings/customers/attributes": {
      "filePath": "_auth/settings/customers/attributes.jsx",
      "parent": "/_auth/settings"
    },
    "/_auth/settings/multi-channels/email": {
      "filePath": "_auth/settings/multi-channels/email.jsx",
      "parent": "/_auth/settings/multi-channels"
    },
    "/_auth/settings/multi-channels/facebook": {
      "filePath": "_auth/settings/multi-channels/facebook.jsx",
      "parent": "/_auth/settings/multi-channels"
    },
    "/_auth/settings/multi-channels/livechat": {
      "filePath": "_auth/settings/multi-channels/livechat.jsx",
      "parent": "/_auth/settings/multi-channels"
    },
    "/_auth/settings/multi-channels/sms": {
      "filePath": "_auth/settings/multi-channels/sms.jsx",
      "parent": "/_auth/settings/multi-channels"
    },
    "/_auth/settings/multi-channels/whatsapp": {
      "filePath": "_auth/settings/multi-channels/whatsapp.jsx",
      "parent": "/_auth/settings/multi-channels"
    },
    "/_auth/settings/multi-channels/zalo": {
      "filePath": "_auth/settings/multi-channels/zalo.jsx",
      "parent": "/_auth/settings/multi-channels"
    },
    "/_auth/settings/organizations/$organizationId": {
      "filePath": "_auth/settings/organizations/$organizationId.jsx",
      "parent": "/_auth/settings"
    },
    "/_auth/settings/others/template-catalogs": {
      "filePath": "_auth/settings/others/template-catalogs.jsx",
      "parent": "/_auth/settings/others"
    },
    "/_auth/settings/others/templates": {
      "filePath": "_auth/settings/others/templates.jsx",
      "parent": "/_auth/settings/others"
    },
    "/_auth/settings/tickets/attributes": {
      "filePath": "_auth/settings/tickets/attributes.jsx",
      "parent": "/_auth/settings/tickets"
    },
    "/_auth/settings/tickets/priority": {
      "filePath": "_auth/settings/tickets/priority.jsx",
      "parent": "/_auth/settings/tickets"
    },
    "/_auth/settings/tickets/service": {
      "filePath": "_auth/settings/tickets/service.jsx",
      "parent": "/_auth/settings/tickets"
    },
    "/_auth/settings/tickets/template": {
      "filePath": "_auth/settings/tickets/template.jsx",
      "parent": "/_auth/settings/tickets"
    },
    "/_auth/settings/tickets/ticket-type": {
      "filePath": "_auth/settings/tickets/ticket-type.jsx",
      "parent": "/_auth/settings/tickets"
    },
    "/_auth/settings/tickets/view": {
      "filePath": "_auth/settings/tickets/view.jsx",
      "parent": "/_auth/settings/tickets"
    },
    "/_auth/settings/users/departments": {
      "filePath": "_auth/settings/users/departments.jsx",
      "parent": "/_auth/settings/users"
    },
    "/_auth/settings/users/members": {
      "filePath": "_auth/settings/users/members.jsx",
      "parent": "/_auth/settings/users"
    },
    "/_auth/settings/users/organizations": {
      "filePath": "_auth/settings/users/organizations.jsx",
      "parent": "/_auth/settings/users"
    },
    "/_auth/smart-qc/criteria/$templateType": {
      "filePath": "_auth/smart-qc/criteria/$templateType.jsx",
      "parent": "/_auth"
    },
    "/_auth/automation/editor/": {
      "filePath": "_auth/automation/editor/index.jsx",
      "parent": "/_auth/automation"
    },
    "/_auth/campaign/$campaignId/": {
      "filePath": "_auth/campaign/$campaignId/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/report/ad-funnel/": {
      "filePath": "_auth/report/ad-funnel/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/settings/tags/": {
      "filePath": "_auth/settings/tags/index.jsx",
      "parent": "/_auth/settings"
    },
    "/_auth/settings/tenant/": {
      "filePath": "_auth/settings/tenant/index.jsx",
      "parent": "/_auth/settings"
    },
    "/_auth/smart-qc/autoQa/": {
      "filePath": "_auth/smart-qc/autoQa/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/smart-qc/campaign/": {
      "filePath": "_auth/smart-qc/campaign/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/smart-qc/criteria/": {
      "filePath": "_auth/smart-qc/criteria/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/smart-qc/dashboard/": {
      "filePath": "_auth/smart-qc/dashboard/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/smart-qc/keyword/": {
      "filePath": "_auth/smart-qc/keyword/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/smart-qc/manualQa/": {
      "filePath": "_auth/smart-qc/manualQa/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/settings/multi-channels/zalo-user/$tenantId": {
      "filePath": "_auth/settings/multi-channels/zalo-user/$tenantId.jsx",
      "parent": "/_auth/settings/multi-channels"
    },
    "/_auth/settings/tenant/config/$tenantId": {
      "filePath": "_auth/settings/tenant/config/$tenantId.jsx",
      "parent": "/_auth/settings/tenant/config"
    },
    "/_auth/settings/multi-channels/zalo-user/": {
      "filePath": "_auth/settings/multi-channels/zalo-user/index.jsx",
      "parent": "/_auth/settings/multi-channels"
    },
    "/_auth/smart-qc/autoQa/$smartQcId/": {
      "filePath": "_auth/smart-qc/autoQa/$smartQcId/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/smart-qc/manualQa/$smartQcId/": {
      "filePath": "_auth/smart-qc/manualQa/$smartQcId/index.jsx",
      "parent": "/_auth"
    },
    "/_auth/smart-qc/autoQa/$smartQcId/calls/$qcTicketId": {
      "filePath": "_auth/smart-qc/autoQa/$smartQcId/calls/$qcTicketId.jsx",
      "parent": "/_auth"
    },
    "/_auth/smart-qc/manualQa/$smartQcId/calls/$qcTicketId": {
      "filePath": "_auth/smart-qc/manualQa/$smartQcId/calls/$qcTicketId.jsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
